import React, { useEffect, useRef, useState, useContext } from "react";
import { useLocation, } from "react-router-dom";
import { Link, useParams } from 'react-router-dom';
import { Button, InputGroup, Modal, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { UserContext } from "../common/UserContext";
import config from "../../envconfig";
import Icon3 from "../../assest/images/Icon3.png";
import { FaPlus, FaCog, FaTags, FaEdit, FaTrash, FaPencilAlt, FaTimes } from "react-icons/fa"; // ➕ icon
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
// import config from "../../../../SmartTrackerPlus_Backend/dbconn";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CustomSingleValue from '../common/CustomSingleValue';


function Home() {
    const allowedCountries = ['in', 'af', 'dz', 'au', 'at', 'be', 'us'];
    const [formData, setFormData] = useState({
        EMTPL_Status: 0,
        EMTPL_EmailEventId: '',
    });
    const [loading, setLoading] = useState(false); // Add loading state
    const [emailList, setEmailList] = useState('');
    const location = useLocation();
    const [eventOption, setEventOption] = useState([]);
    const [statusOption, setstatusOption] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const [keyWords, setKeyWords] = useState({});
    const [setting, setSetting] = useState({});
    const [emailBody, setEmailBody] = useState('   ');
    const [errMsg, setErrMsg] = useState({});
    const [disableField, setDisabaled] = useState(false);
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType } = useContext(UserContext);

    const [scpOptions, setScpOptions] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [filteredScpNames, setFilteredScpNames] = useState([]);
    const [selectedScpName, setSelectedScpName] = useState('');
    const [scpData, setScpData] = useState([]);
    const [selectedFromScpId, setSelectedFromScpId] = useState("");
    const [selectedFromScpName, setSelectedFromScpName] = useState("");
    const [selectedEvent, setSelectedEvent] = useState('');
    const [selectedShipmentType, setSelectedShipmentType] = useState('');
    const [isFirstVisit, setIsFirstVisit] = useState(true);
    const [disableScpDropdown, setDisableScpDropdown] = useState(true);
    const [showAsterisks, setShowAsterisks] = useState({});
    const [error, setError] = useState(null);
    const [createdByScp, setCreatedByScp] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);
    const [selectedFromScpLevelNo, setSelectedFromScpLevelNo] = useState("");
    const [disabled, setDisabled] = useState(false);
    const id = new URLSearchParams(location.search).get("id");
    const [selectedtoscp, setselectedtoscp] = useState(false);
    const [selectedevent, setselectedevent] = useState(false);
    const [selectedShipmentTypename, setSelectedShipmentTypename] = useState(false);

    const [isSelectOpen, setIsSelectOpen] = useState(null);
    let isMountVal = useRef(true);
    const [transmissionOptions, setTransmissionOptions] = useState([]);
    const [selectedTransmission, setSelectedTransmission] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [newUserName, setNewUserName] = useState("");
    const [newlyAddedUsers, setNewlyAddedUsers] = useState([]);
    const [newUserContact, setNewUserContact] = useState("");
    const [userCount, setUserCount] = useState(0); // To track Added User number
    const [editingUser, setEditingUser] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [modalTempList, setModalTempList] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [showInputAsterisk, setShowInputAsterisk] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState('in'); // default India
    const [selectedDialCode, setSelectedDialCode] = useState("91"); // for phone validation
    const phoneLengthMapping = {
        "91": 10,
        "93": 9,
        "213": 9,
        "61": 9,
        "43": 10,
        "32": 9,
        "1": 10,
    };
    const [shouldCloseModalAfterUpdate, setShouldCloseModalAfterUpdate] = useState(false);

    const shipmentTypeOptions = [
        { value: 1, label: 'Outward' },
        // { value: 2, label: 'Inward' }
    ];
    const toastRef = useRef(null);

    // In your component, update the state handling for newlyAddedUsers

    // Also add a state to track checkbox states
    const [userCheckboxStates, setUserCheckboxStates] = useState({});
    const showToast = (type, message, options = {}) => {
        if (toastRef.current && toast.isActive(toastRef.current)) {
            toast.update(toastRef.current, {
                render: message,
                type,
                autoClose: 3000,
                ...options,
            });
        } else {
            toastRef.current = toast[type](message, {
                autoClose: 3000,
                ...options,
            });
        }
    };
    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('UM_UserType', UM_UserType);
        sessionStorage.setItem('selectedScpId', selectedScpId);
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId, UM_UserType]);

    useEffect(() => {
        const fetchGroupNames = async () => {
            try {

                const domainUserInt = parseInt(UM_UserType, 10);
                const adminCheck = domainUserInt === 1;
                setIsAdmin(adminCheck);

                if (adminCheck) {
                    // Fetch data from the second API
                    const scpResponse = await fetch(`${config.API_URL}/OM/api/scpmaster/${UM_CompanyID}`);
                    const scpData = await scpResponse.json();
                    setScpData(scpData);

                } else {


                    const scpResponse = await fetch(`${config.API_URL}/OM/fetchScpDetails/${selectedScpId}`);
                    const scpData = await scpResponse.json();

                    setCreatedByScp(scpData.SCPM_ID);
                    setSelectedFromScpName(scpData.SCPM_Name);
                    setSelectedFromScpLevelNo(scpData.SCPM_LevelNo);

                }
            } catch (error) {
                setError("Failed to fetch data");
                console.error("Fetch Error:", error);
                logAction('Failed to fetch scp data in fetchGroupNames function', true);
            }
        };

        fetchGroupNames();
    }, [UM_GroupId, UM_CompanyID, selectedFromScpId, UM_UserType]);

    const handleEditUser = (user) => {
        if (!user) return;
        console.log("user-----", user)
        console.log("user value-----", user.value)
        setEditingId(user.value);
        setEditingUser(user || null);

        // We'll handle modal closing differently
        setShouldCloseModalAfterUpdate(false);

        // Prefill input - extract just the number/email without formatting
        const prefill = parseInt(selectedTransmission) === 2
            ? (user.phone || user.raw || '')
            : (user.email || user.raw || '');

        // For phone, remove the +91 prefix if present
        if (parseInt(selectedTransmission) === 2 && prefill) {
            // Remove country code prefix like "+91 "
            const phoneWithoutPrefix = prefill.replace(/^\+\d+\s*/, '');
            setNewUserContact(phoneWithoutPrefix);
        } else {
            setNewUserContact(prefill);
        }

        setShowInputAsterisk(false);
        setShowModal(true);
    };
    // 🗑️ Step 1: Open modal when delete is clicked
    const handleDeleteUser = (userValue) => {
        setUserToDelete(userValue); // store which user is to be deleted
        setShowDeleteModal(true);   // show the modal
    };


    const confirmDeleteUser = () => {
        if (!userToDelete) return;
        setScpOptions((prev) => prev.filter((u) => u.value !== userToDelete));
        setSelectedUsers((prev) => prev.filter((id) => id !== userToDelete));
        setNewlyAddedUsers((prev) => prev.filter((u) => u.value !== userToDelete));
        // Show success message
        showToast('success', 'User deleted successfully.');
        setUserToDelete(null);
        setShowDeleteModal(false);
    };

    useEffect(() => {
        const fetchTransmissionModes = async () => {
            try {
                const response = await fetch(`${config.API_URL}/transmission-mode`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ CM_ID: UM_CompanyID }),
                });

                const result = await response.json();

                if (result.success && Array.isArray(result.data)) {
                    // Convert the result array into react-select format
                    const formatted = result.data.map(item => ({
                        value: Number(item.EnumVal),    // react-select value
                        label: item.Description       // react-select label
                    }));
                    setTransmissionOptions(formatted);
                } else {
                    console.warn("No transmission modes found");
                }
            } catch (error) {
                console.error("Error fetching transmission modes:", error);
            }
        };

        if (UM_CompanyID) {
            fetchTransmissionModes();
        }
    }, [UM_CompanyID]);



    // Fetch details for the selected SCP for normal users
    useEffect(() => {
        if (!isAdmin && selectedFromScpId) {

            fetch(`${config.API_URL}/OM/fetchScpDetails/${selectedFromScpId}`)
                .then(response => response.json())
                .then(data => {

                    if (data && data.SCPM_Name) {
                        setCreatedByScp(data.SCPM_ID);
                        setSelectedFromScpName(data.SCPM_Name);
                        setSelectedFromScpLevelNo(data.SCPM_LevelNo);

                    }
                })
                .catch(error => {
                    console.error('Error fetching SCP details:', error);
                    logAction('Error fetching SCP details', true);
                });
        }
    }, [selectedFromScpId, isAdmin]);


    useEffect(() => {
        setIsFirstVisit(false);
    }, []);

    // useEffect(() => {

    //     if ((selectedEvent === 2 || selectedEvent === 3) && selectedShipmentType) {

    //         fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedScpId}/${selectedEvent}/${selectedShipmentType}`)

    //             .then(response => response.json())
    //             .then(data => {

    //                 const SCPs = data.SCPs;
    //                 const options = SCPs.map(scp => ({
    //                     label: scp.SCPM_Name,
    //                     value: scp.SCPM_ID
    //                 }));


    //                 setFilteredScpNames(options);


    //                 fetch(`${config.API_URL}/api/email/shipmenttype/${selectedScpId}/${selectedEvent}/${selectedShipmentType}/${parseInt(selectedTransmission)}`)
    //                     .then(response => {
    //                         if (!response.ok) {
    //                             logAction(`API Execution Failed : /api/email/shipmenttype/ with parameters ${selectedScpId}, ${selectedEvent}, ${selectedShipmentType}`, true);
    //                             throw new Error('Network response was not ok');

    //                         }
    //                         return response.json();
    //                     })
    //                     .then(emailData => {

    //                         const usedEvents = emailData.map(event => ({
    //                             SCPM_ID: event.EMTPL_TOSCPID,
    //                             EmailEventId: event.EMTPL_EmailEventId
    //                         }));
    //                         let updatedOptions;
    //                         if (selectedEvent === 2) {
    //                             updatedOptions = options.map(option => ({
    //                                 ...option,
    //                                 disabled: usedEvents.some(usedEvent =>
    //                                     usedEvent.SCPM_ID === option.value && usedEvent.EmailEventId === 2
    //                                 )
    //                             }));
    //                         } else if (selectedEvent === 3) {
    //                             updatedOptions = options.map(option => ({
    //                                 ...option,
    //                                 disabled: usedEvents.some(usedEvent =>
    //                                     usedEvent.SCPM_ID === option.value && usedEvent.EmailEventId === 3
    //                                 )
    //                             }));
    //                         }
    //                         setFilteredScpNames(updatedOptions);

    //                     })
    //                     .catch(error => {
    //                         console.error('Error fetching email template data:', error);
    //                         logAction('Error fetching email template data', true);
    //                     });
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching SCP names:', error);
    //                 logAction('Error fetching SCP names', true);
    //             });
    //     }
    //     else if (selectedEvent === 1) {

    //         fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedScpId}/${selectedEvent}/2`)
    //             .then(response => response.json())
    //             .then(data => {
    //                 logAction('Successfully fetched SCP names for selectedEvent Order');
    //                 const SCPs = data.SCPs;
    //                 const options = SCPs.map(scp => ({
    //                     label: scp.SCPM_Name,
    //                     value: scp.SCPM_ID
    //                 }));

    //                 setFilteredScpNames(options);

    //                 console.log("selectedTransmission", selectedFromScpId, selectedTransmission)
    //                 fetch(`${config.API_URL}/api/email/order/${selectedScpId}/${parseInt(selectedTransmission)}`)  // Assuming '2' for shipment type here
    //                     .then(response => response.json())
    //                     .then(emailData => {
    //                         logAction('Successfully fetched email template data for order');
    //                         const usedEvents = emailData.map(event => ({
    //                             SCPM_ID: event.EMTPL_TOSCPID,
    //                             EmailEventId: event.EMTPL_EmailEventId
    //                         }));

    //                         console.log("order options", emailData, usedEvents, options)
    //                         const updatedOptions = options.map(option => ({
    //                             ...option,
    //                             disabled: usedEvents.some(usedEvent =>
    //                                 usedEvent.SCPM_ID === option.value && usedEvent.EmailEventId === 1
    //                             )
    //                         }));

    //                         setFilteredScpNames(updatedOptions);
    //                         logAction('Updated SCP names with disabled options');
    //                     })
    //                     .catch(error => {
    //                         console.error('Error fetching email template data:', error);
    //                         logAction('Error fetching email template data', true);
    //                     });
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching SCP names:', error);
    //                 logAction('Error fetching SCP names', true);
    //             });
    //     }

    //     // else if (selectedEvent === 4) {
    //     else if (selectedEvent === 4 || selectedEvent === 6) {
    //         console.log("selectedEvent", selectedScpId, selectedEvent)

    //         fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedScpId}/${selectedEvent}/2`)
    //             .then(response => response.json())
    //             .then(data => {

    //                 const SCPs = data.SCPs;
    //                 const options = SCPs.map(scp => ({
    //                     label: scp.SCPM_Name,
    //                     value: scp.SCPM_ID
    //                 }));

    //                 console.log("options", options)

    //                 setFilteredScpNames(options);

    //                 console.log("selectedTransmission", selectedFromScpId, selectedTransmission)
    //                 fetch(`${config.API_URL}/api/email/order/${selectedScpId}/${parseInt(selectedTransmission)}`)  // Assuming '2' for shipment type here
    //                     .then(response => response.json())
    //                     .then(emailData => {
    //                         console.log("emailData for event 4:", emailData);
    //                         const usedEvents = emailData.map(event => ({
    //                             SCPM_ID: event.EMTPL_TOSCPID,
    //                             EmailEventId: event.EMTPL_EmailEventId
    //                         }));

    //                         console.log("order options", emailData, usedEvents, options)
    //                         const updatedOptions = options.map(option => ({
    //                             ...option,
    //                             disabled: usedEvents.some(usedEvent =>
    //                                 usedEvent.SCPM_ID === option.value && usedEvent.EmailEventId === 1
    //                             )
    //                         }));

    //                         setFilteredScpNames(updatedOptions);
    //                         logAction('Updated SCP names with disabled options');
    //                     })
    //                     .catch(error => {
    //                         console.error('Error fetching email template data:', error);
    //                         logAction('Error fetching email template data', true);
    //                     });
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching SCP names:', error);
    //                 logAction('Error fetching SCP names', true);
    //             });
    //     }

    // }, [selectedScpId, selectedEvent, selectedShipmentType, formData.EMTPL_EmailEventId]);

    // useEffect(() => {

    //     if ((selectedEvent === 2 || selectedEvent === 3) && selectedShipmentType) {

    //         fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedFromScpId}/${selectedEvent}/${selectedShipmentType}`)
    //             .then(response => response.json())
    //             .then(data => {
    //                 logAction('Successfully fetched SCP names for selectedEvent 2 or 3');
    //                 const SCPs = data.SCPs;

    //                 const options = SCPs.map(scp => ({
    //                     label: scp.SCPM_Name,
    //                     value: scp.SCPM_ID
    //                 }));

    //                 setFilteredScpNames(options);
    //                 logAction('Set filtered SCP names options');
    //                 // Call the second API here after setting filteredScpNames
    //                 logAction(`Executing API: /api/email/shipmenttype/ with parameters ${selectedFromScpId}, ${selectedEvent}, ${selectedShipmentType}`);
    //                 fetch(`${config.API_URL}/api/email/shipmenttype/${selectedFromScpId}/${selectedEvent}/${selectedShipmentType}/${parseInt(selectedTransmission)}`)
    //                     .then(response => {
    //                         if (!response.ok) {
    //                             logAction(`Execution of  API Failed: /api/email/shipmenttype/ with parameters ${selectedFromScpId}, ${selectedEvent}, ${selectedShipmentType}`, true);
    //                             throw new Error('Network response was not ok');
    //                         }
    //                         return response.json();
    //                     })
    //                     .then(emailData => {
    //                         logAction('Successfully fetched email template data for shipment type');
    //                         // Process emailData to disable options in the dropdown
    //                         const usedEvents = emailData.map(event => ({
    //                             SCPM_ID: event.EMTPL_TOSCPID,
    //                             EmailEventId: event.EMTPL_EmailEventId
    //                         }));

    //                         let updatedOptions;
    //                         console.log("selectedEvent", selectedEvent, usedEvents, options)

    //                         if (selectedEvent === 2) {
    //                             updatedOptions = options.map(option => ({
    //                                 ...option,
    //                                 disabled: usedEvents.some(usedEvent =>
    //                                     usedEvent.SCPM_ID === option.value && usedEvent.EmailEventId === 2
    //                                 )
    //                             }));
    //                         } else if (selectedEvent === 3) {
    //                             updatedOptions = options.map(option => ({
    //                                 ...option,
    //                                 disabled: usedEvents.some(usedEvent =>
    //                                     usedEvent.SCPM_ID === option.value && usedEvent.EmailEventId === 3
    //                                 )
    //                             }));
    //                         }

    //                         setFilteredScpNames(updatedOptions);
    //                         logAction('Updated SCP names with disabled options');
    //                     })
    //                     .catch(error => {
    //                         console.error('Error fetching email template data:', error);
    //                         logAction('Error fetching email template data', true);
    //                     });
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching SCP names:', error);
    //                 logAction('Error fetching SCP names', true);
    //             });
    //     }
    //     else if (selectedEvent === 1) {


    //         fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedFromScpId}/${selectedEvent}/2`)
    //             .then(response => response.json())
    //             .then(data => {
    //                 logAction('Successfully fetched SCP names for selectedEvent Order');
    //                 const SCPs = data.SCPs;

    //                 const options = SCPs.map(scp => ({
    //                     label: scp.SCPM_Name,
    //                     value: scp.SCPM_ID
    //                 }));

    //                 setFilteredScpNames(options);
    //                 logAction('Set filtered SCP names options');
    //                 // Call the second API for email template data

    //                 fetch(`${config.API_URL}/api/email/order/${selectedFromScpId}/${parseInt(selectedTransmission)}`)  // Assuming '2' for shipment type here
    //                     .then(response => response.json())
    //                     .then(emailData => {
    //                         console.log("emailDataemailData", emailData)
    //                         // Process emailData to disable options in the dropdown
    //                         const usedEvents = emailData.map(event => ({
    //                             SCPM_ID: event.EMTPL_TOSCPID,
    //                             EmailEventId: event.EMTPL_EmailEventId
    //                         }));

    //                         // Update the dropdown options with disabled state
    //                         const updatedOptions = options.map(option => ({
    //                             ...option,
    //                             disabled: usedEvents.some(usedEvent =>
    //                                 usedEvent.SCPM_ID === option.value && usedEvent.EmailEventId === 1
    //                             )
    //                         }));

    //                         setFilteredScpNames(updatedOptions);
    //                         logAction('Updated SCP names with disabled options');
    //                     })
    //                     .catch(error => {
    //                         console.error('Error fetching email template data:', error);
    //                         logAction('Error fetching email template data', true);
    //                     });
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching SCP names:', error);
    //                 logAction('Error fetching SCP names', true);
    //             });
    //     }

    //     // else if (selectedEvent === 4) {
    //     else if (selectedEvent === 4 || selectedEvent === 6) {


    //         fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedFromScpId}/${selectedEvent}/2`)
    //             .then(response => response.json())
    //             .then(data => {
    //                 logAction('Successfully fetched SCP names for selectedEvent Order');
    //                 const SCPs = data.SCPs;

    //                 const options = SCPs.map(scp => ({
    //                     label: scp.SCPM_Name,
    //                     value: scp.SCPM_ID
    //                 }));

    //                 setFilteredScpNames(options);
    //                 logAction('Set filtered SCP names options');
    //                 // Call the second API for email template data

    //                 fetch(`${config.API_URL}/api/email/order/${selectedFromScpId}/${parseInt(selectedTransmission)}`)  // Assuming '2' for shipment type here
    //                     .then(response => response.json())
    //                     .then(emailData => {
    //                         console.log("emailDataemailData", emailData)
    //                         // Process emailData to disable options in the dropdown
    //                         const usedEvents = emailData.map(event => ({
    //                             SCPM_ID: event.EMTPL_TOSCPID,
    //                             EmailEventId: event.EMTPL_EmailEventId
    //                         }));

    //                         // Update the dropdown options with disabled state
    //                         const updatedOptions = options.map(option => ({
    //                             ...option,
    //                             disabled: usedEvents.some(usedEvent =>
    //                                 usedEvent.SCPM_ID === option.value && usedEvent.EmailEventId === 1
    //                             )
    //                         }));

    //                         setFilteredScpNames(updatedOptions);
    //                         logAction('Updated SCP names with disabled options');
    //                     })
    //                     .catch(error => {
    //                         console.error('Error fetching email template data:', error);
    //                         logAction('Error fetching email template data', true);
    //                     });
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching SCP names:', error);
    //                 logAction('Error fetching SCP names', true);
    //             });
    //     }

    // }, [selectedFromScpId, selectedEvent, selectedShipmentType]);
    // For admin users (when they select a From SCP)
    useEffect(() => {
        if ((selectedEvent === 2 || selectedEvent === 3) && selectedShipmentType) {
            fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedFromScpId}/${selectedEvent}/${selectedShipmentType}`)
                .then(response => response.json())
                .then(data => {
                    logAction('Successfully fetched SCP names for selectedEvent 2 or 3');
                    const SCPs = data.SCPs;
                    const options = SCPs.map(scp => ({
                        label: scp.SCPM_Name,
                        value: scp.SCPM_ID
                    }));

                    // Call the second API here to check for existing configurations
                    fetch(`${config.API_URL}/api/email/shipmenttype/${selectedFromScpId}/${selectedEvent}/${selectedShipmentType}/${parseInt(selectedTransmission)}`)
                        .then(response => {
                            if (!response.ok) {
                                logAction(`Execution of API Failed: /api/email/shipmenttype/ with parameters ${selectedFromScpId}, ${selectedEvent}, ${selectedShipmentType}`, true);
                                throw new Error('Network response was not ok');
                            }
                            return response.json();
                        })
                        .then(emailData => {
                            logAction('Successfully fetched email template data for shipment type');

                            // FIX: Check for configurations where FROMSCPID = selectedFromScpId 
                            // and TOSCPID matches the option value for the same event
                            const existingConfigs = emailData.map(event => ({
                                FROM_SCP_ID: event.EMTPL_FROMSCPID,  // Add this - the source SCP
                                TO_SCP_ID: event.EMTPL_TOSCPID,
                                EmailEventId: event.EMTPL_EmailEventId
                            }));
                            console.log("existingConfigs", existingConfigs)
                            console.log("Options before disabling", options)
                            console.log("selectedEvent", selectedEvent)
                            // let updatedOptions;
                            // if (selectedEvent === 2) {
                            //     updatedOptions = options.map(option => ({
                            //         ...option,
                            //         // Disable if there's already a configuration FROM the selected From SCP 
                            //         // TO this specific TO SCP for this event
                            //         disabled: existingConfigs.some(config =>
                            //             config.FROM_SCP_ID === selectedFromScpId &&
                            //             config.TO_SCP_ID === option.value &&
                            //             config.EmailEventId === 2
                            //         )
                            //     }));
                            // } else if (selectedEvent === 3) {
                            //     updatedOptions = options.map(option => ({
                            //         ...option,
                            //         disabled: existingConfigs.some(config =>
                            //             config.FROM_SCP_ID === selectedFromScpId &&
                            //             config.TO_SCP_ID === option.value &&
                            //             config.EmailEventId === 3
                            //         )
                            //     }));
                            // }

                            const updatedOptions = options.map(option => ({
                                ...option,
                                isDisabled: existingConfigs.some(config =>
                                    config.TO_SCP_ID === option.value &&
                                    config.EmailEventId === selectedEvent
                                )
                            }));

                            console.log("after disabling options", updatedOptions)

                            setFilteredScpNames(updatedOptions);
                            logAction('Updated SCP names with disabled options');
                        })
                        .catch(error => {
                            console.error('Error fetching email template data:', error);
                            logAction('Error fetching email template data', true);
                        });
                })
                .catch(error => {
                    console.error('Error fetching SCP names:', error);
                    logAction('Error fetching SCP names', true);
                });
        }
        else if (selectedEvent === 1) {
            fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedFromScpId}/${selectedEvent}/2`)
                .then(response => response.json())
                .then(data => {
                    logAction('Successfully fetched SCP names for selectedEvent Order');

                    const SCPs = data.SCPs || [];

                    const options = SCPs.map(scp => ({
                        label: scp.SCPM_Name,
                        value: scp.SCPM_ID
                    }));

                    console.log("scp123", options);

                    // If no options found, just set empty and return
                    if (!options.length) {
                        setFilteredScpNames([]);
                        return;
                    }

                    // Second API call
                    fetch(`${config.API_URL}/api/email/order/${selectedFromScpId}/${parseInt(selectedTransmission)}/${parseInt(selectedEvent)}`)
                        .then(response => response.json())
                        .then(result => {

                            console.log("Full API response:", result);

                            const emailData = result?.data || [];

                            if (!Array.isArray(emailData) || emailData.length === 0) {
                                setFilteredScpNames(options);
                                return;
                            }

                            const updatedOptions = options.map(option => ({
                                ...option,
                                isDisabled: emailData.some(event =>
                                    Number(event.EMTPL_TOSCPID) === Number(option.value) &&
                                    Number(event.EMTPL_EmailEventId) === 1
                                )
                            }));
                            console.log("updatedOptions", updatedOptions);

                            setFilteredScpNames(updatedOptions);
                        })
                        .catch(error => {
                            console.error('Error fetching email template data:', error);

                            // IMPORTANT: Still show options if second API fails
                            setFilteredScpNames(options);

                            logAction('Error fetching email template data', true);
                        });
                })
                .catch(error => {
                    console.error('Error fetching SCP names:', error);
                    logAction('Error fetching SCP names', true);
                });
        }
        else if (selectedEvent === 4 || selectedEvent === 6) {
            fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedFromScpId}/${selectedEvent}/2`)
                .then(response => response.json())
                .then(data => {
                    logAction('Successfully fetched SCP names for selectedEvent Order');
                    const SCPs = data.SCPs;
                    const options = SCPs.map(scp => ({
                        label: scp.SCPM_Name,
                        value: scp.SCPM_ID
                    }));

                    // Call the second API for email template data
                    console.log("selectedTransmission", selectedFromScpId, selectedTransmission)
                    fetch(`${config.API_URL}/api/email/order/${selectedFromScpId}/${parseInt(selectedTransmission)}/${parseInt(selectedEvent)}`)
                        .then(response => response.json())
                        .then(result => {

                            const emailData = result?.data || [];

                            console.log("emailData for event 4/6:", emailData);

                            if (!Array.isArray(emailData) || emailData.length === 0) {
                                setFilteredScpNames(options);
                                return;
                            }

                            const updatedOptions = options.map(option => ({
                                ...option,
                                isDisabled: emailData.some(event =>
                                    Number(event.EMTPL_TOSCPID) === Number(option.value)
                                )
                            }));

                            setFilteredScpNames(updatedOptions);
                        })
                        .catch(error => {
                            console.error('Error fetching email template data:', error);
                            logAction('Error fetching email template data', true);
                        });
                })
                .catch(error => {
                    console.error('Error fetching SCP names:', error);
                    logAction('Error fetching SCP names', true);
                });
        }
    }, [selectedFromScpId, selectedEvent, selectedShipmentType]);

    // For non-admin users (using their default SCP)
    useEffect(() => {
        if ((selectedEvent === 2 || selectedEvent === 3) && selectedShipmentType) {
            fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedScpId}/${selectedEvent}/${selectedShipmentType}`)
                .then(response => response.json())
                .then(data => {
                    const SCPs = data.SCPs;
                    const options = SCPs.map(scp => ({
                        label: scp.SCPM_Name,
                        value: scp.SCPM_ID
                    }));

                    fetch(`${config.API_URL}/api/email/shipmenttype/${selectedScpId}/${selectedEvent}/${selectedShipmentType}/${parseInt(selectedTransmission)}`)
                        .then(response => {
                            if (!response.ok) {
                                logAction(`API Execution Failed : /api/email/shipmenttype/ with parameters ${selectedScpId}, ${selectedEvent}, ${selectedShipmentType}`, true);
                                throw new Error('Network response was not ok');
                            }
                            return response.json();
                        })
                        .then(emailData => {
                            // FIX: Check for configurations where FROMSCPID = selectedScpId
                            const existingConfigs = emailData.map(event => ({
                                FROM_SCP_ID: event.EMTPL_FROMSCPID,
                                TO_SCP_ID: event.EMTPL_TOSCPID,
                                EmailEventId: event.EMTPL_EmailEventId
                            }));

                            let updatedOptions;
                            if (selectedEvent === 2) {
                                updatedOptions = options.map(option => ({
                                    ...option,
                                    // Disable if there's already a configuration FROM the current SCP
                                    // TO this specific TO SCP for this event
                                    isDisabled: existingConfigs.some(config =>
                                        config.FROM_SCP_ID === selectedScpId &&
                                        config.TO_SCP_ID === option.value &&
                                        config.EmailEventId === 2
                                    )
                                }));
                            } else if (selectedEvent === 3) {
                                updatedOptions = options.map(option => ({
                                    ...option,
                                    disabled: existingConfigs.some(config =>
                                        config.FROM_SCP_ID === selectedScpId &&
                                        config.TO_SCP_ID === option.value &&
                                        config.EmailEventId === 3
                                    )
                                }));
                            }
                            setFilteredScpNames(updatedOptions);
                        })
                        .catch(error => {
                            console.error('Error fetching email template data:', error);
                            logAction('Error fetching email template data', true);
                        });
                })
                .catch(error => {
                    console.error('Error fetching SCP names:', error);
                    logAction('Error fetching SCP names', true);
                });
        }
        else if (selectedEvent === 1) {
            fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedScpId}/${selectedEvent}/2`)
                .then(response => response.json())
                .then(data => {
                    const SCPs = data.SCPs;
                    const options = SCPs.map(scp => ({
                        label: scp.SCPM_Name,
                        value: scp.SCPM_ID
                    }));

                    console.log("scps12", options)

                    fetch(`${config.API_URL}/api/email/order/${selectedScpId}/${parseInt(selectedTransmission)}/${parseInt(selectedEvent)}`)
                        .then(response => response.json())
                        .then(emailData => {
                            // FIX: Check for configurations where FROMSCPID = selectedScpId
                            const existingConfigs = emailData.map(event => ({
                                FROM_SCP_ID: event.EMTPL_FROMSCPID,
                                TO_SCP_ID: event.EMTPL_TOSCPID,
                                EmailEventId: event.EMTPL_EmailEventId
                            }));

                            const updatedOptions = options.map(option => ({
                                ...option,
                                // Disable if there's already a configuration FROM the current SCP
                                // TO this specific TO SCP for Order event (event 1)
                                disabled: existingConfigs.some(config =>
                                    config.FROM_SCP_ID === selectedScpId &&
                                    config.TO_SCP_ID === option.value &&
                                    config.EmailEventId === 1
                                )
                            }));

                            setFilteredScpNames(updatedOptions);
                        })
                        .catch(error => {
                            console.error('Error fetching email template data:', error);
                            logAction('Error fetching email template data', true);
                        });
                })
                .catch(error => {
                    console.error('Error fetching SCP names:', error);
                    logAction('Error fetching SCP names', true);
                });
        }
        else if (selectedEvent === 4 || selectedEvent === 6) {
            fetch(`${config.API_URL}/ToSCPFOREMAIL/${selectedScpId}/${selectedEvent}/2`)
                .then(response => response.json())
                .then(data => {
                    const SCPs = data.SCPs;
                    const options = SCPs.map(scp => ({
                        label: scp.SCPM_Name,
                        value: scp.SCPM_ID
                    }));

                    console.log("scps", options)

                    fetch(`${config.API_URL}/api/email/order/${selectedScpId}/${parseInt(selectedTransmission)}/${parseInt(selectedEvent)}`)
                        .then(response => response.json())
                        .then(emailData => {
                            // FIX: Check for configurations where FROMSCPID = selectedScpId
                            const existingConfigs = emailData.map(event => ({
                                FROM_SCP_ID: event.EMTPL_FROMSCPID,
                                TO_SCP_ID: event.EMTPL_TOSCPID,
                                EmailEventId: event.EMTPL_EmailEventId
                            }));

                            const updatedOptions = options.map(option => ({
                                ...option,
                                // Disable if there's already a configuration FROM the current SCP
                                // TO this specific TO SCP for Order event (event 1)
                                disabled: existingConfigs.some(config =>
                                    config.FROM_SCP_ID === selectedScpId &&
                                    config.TO_SCP_ID === option.value &&
                                    config.EmailEventId === 1
                                )
                            }));

                            setFilteredScpNames(updatedOptions);
                        })
                        .catch(error => {
                            console.error('Error fetching email template data:', error);
                            logAction('Error fetching email template data', true);
                        });
                })
                .catch(error => {
                    console.error('Error fetching SCP names:', error);
                    logAction('Error fetching SCP names', true);
                });
        }
    }, [selectedScpId, selectedEvent, selectedShipmentType, formData.EMTPL_EmailEventId]);
    useEffect(() => {
        const fetchData = async () => {
            if (isMountVal.current) {
                try {

                    // API call for events
                    const eventResponse = await fetch(
                        `${config.API_URL}/api/email/events`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                UM_CompanyID,
                                UM_UserType
                            })
                        }
                    );

                    if (!eventResponse.ok) {
                        throw new Error(`HTTP error! status: ${eventResponse.status}`);
                    }
                    const eventData = await eventResponse.json();
                    console.log("eventData", eventData)
                    setEventOption(eventData);
                    logAction('Successfully fetched event data');

                } catch (err) {
                    logAction('Error fetching event data', true);
                    console.log("error for fetching events", err);
                }

                try {

                    // API call for status
                    const statusResponse = await fetch(`${config.API_URL}/api/email/status`);
                    if (!statusResponse.ok) {
                        throw new Error(`HTTP error! status: ${statusResponse.status}`);
                    }
                    const statusData = await statusResponse.json();
                    setstatusOption(statusData);
                    logAction('Successfully fetched status data');

                } catch (err) {
                    logAction('Error fetching status data', true);
                    console.log("error for fetching status", err);
                }
            }
            isMountVal.current = false; // Set to false after the first render
        };

        fetchData();
    }, [id, UM_CompanyID, UM_UserType]);


    const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
        const auditLogPayload = {
            AUTR_ScreenName: module,
            AUTR_OldValue: oldValue,
            AUTR_NewValue: newValue,
            AUTR_Message: message,
            AUTR_UserID: UM_UserId,
            AUTR_UserName: UM_UserCode,
            AUTR_AuditType: 15,
            AUTR_SCPID: selectedScpId,
            AUTR_CompanyGrpId: UM_CompanyGrpID,
            AUTR_CompanyID: UM_CompanyID,
            AUTR_CreatedBy: UM_UserId,
            insertAuditTransaction: true, // Flag to determine if transaction details should be inserted
            transactionDetails // Array of transaction details to be inserted into audittransaction
        };

        try {
            const response = await fetch(`${config.API_URL}/audit/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(auditLogPayload),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };


    const logAction = async (action, isError = false) => {

        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "Message Configuration", action, userCode: UM_UserCode, isError }),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };


    const handleChangetoscp = async (selectedOption) => {
        const newValue = selectedOption ? selectedOption.value : null;
        const newValuename = selectedOption ? selectedOption.label : null;

        logAction(`handleChangetoscp triggered with: ${newValuename}`);

        setSelectedScpName(newValue);
        setselectedtoscp(newValuename);

        // Reset all user selections when To SCP changes
        setSelectedUsers([]);
        setNewlyAddedUsers([]);
        setScpOptions([]);
        setUserCheckboxStates({});

        // Asterisk logic
        if (!newValue) {
            setShowAsterisks(prev => ({ ...prev, selectedScpName: true }));
            logAction('selectedScpName set to true');
        } else {
            setShowAsterisks(prev => ({ ...prev, selectedScpName: false }));
            logAction('selectedScpName set to false');
        }

        document.getElementById('tscp').style.display = 'none';

        // API call
        if (newValue) {
            try {
                const response = await fetch(`${config.API_URL}/users`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        SCP_ID: newValue,
                        CompanyID: UM_CompanyID,
                        TransmissionMode: selectedTransmission // Add this parameter
                    })
                });

                const data = await response.json();

                if (data.success) {
                    const userOptions = data.data.map(user => ({
                        value: user.UM_UserId,
                        label: user.UM_UserCode,
                        phone: user.UM_PhoneNumber,
                        email: user.UM_EmailAddress,
                        type: 'master' // Add type to distinguish
                    }));
                    setScpOptions(userOptions);

                    // Initialize checkbox states
                    const initialStates = {};
                    userOptions.forEach(user => {
                        initialStates[user.value] = 0;
                    });
                    setUserCheckboxStates(initialStates);

                    logAction("SCP options updated");
                } else {
                    setScpOptions([]);
                    setUserCheckboxStates({});
                }
            } catch (error) {
                console.error("Error fetching users:", error);
                setScpOptions([]);
                setUserCheckboxStates({});
            }
        }
    };

    const showKeyWords = async () => {

        logAction('Calling showKeyWords Function');
        if (formData.EMTPL_EmailEventId !== "") {
            logAction('Opening modal to show keywords');
            setOpenModal(true);

            try {
                logAction(`Executing API: /api/email/keywords/${formData.EMTPL_EmailEventId}`);
                const response = await fetch(`${config.API_URL}/api/email/keywords/${formData.EMTPL_EmailEventId}`);
                if (!response.ok) {
                    logAction(`API Execution Failed: /api/email/keywords/${formData.EMTPL_EmailEventId}`, true);
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setKeyWords(data);  // Assuming setKeyWords is a state setter function
                logAction('Successfully fetched and set keywords');

            } catch (err) {
                logAction('Error fetching keywords', true);
                console.log("Error for fetching keywords:", err);
            }
        } else {

            showToast('error', 'Please select Event Type.', {
                autoClose: 3000,
            });
            return;
        }
    }


    const emailSetting = async () => {
        logAction('Calling emailSetting Function');

        setEmailModal(true);

        try {
            logAction('Executing API: /api/email/setting');
            const response = await fetch(`${config.API_URL}/api/email/setting`);

            if (!response.ok) {
                logAction('API Execution Failed: /api/email/setting', true);
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setSetting(data);
            logAction('Successfully fetched and set email settings');
        } catch (err) {
            logAction('Error fetching email settings', true);
            console.log("Error for fetching settings:", err);
        }
    };



    const hideKeyWords = () => {
        logAction('Closed keywords modal');
        setOpenModal(false);
    }
    const handleChange = (e) => {
        logAction(`handleChange function Called`);
        const { name, value } = e.target;

        setEmailList(value);
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
        logAction(`Updated form field: ${name} with value: ${value}`);

        // Reset error message for the current field
        setErrMsg(prevErrMsg => ({
            ...prevErrMsg,
            [name]: '',
        }));
        logAction(`Reset error message for field: ${name}`);

        // Clear asterisk when user starts typing
        if (name === "EMTPL_Subject") {
            // If user types something, remove the asterisk
            if (value && showAsterisks.EMTPL_Subject) {
                setShowAsterisks(prevAsterisks => ({
                    ...prevAsterisks,
                    EMTPL_Subject: false
                }));
                logAction(`Removed asterisk for EMTPL_Subject as user started typing`);
            }
        }
    };

    const handleSCPListChange = (value) => {
        setSelectedUsers(prev => {
            if (prev.includes(value)) {
                // User unchecked - remove from selected
                setUserCheckboxStates(prevStates => ({
                    ...prevStates,
                    [value]: 0 // Set to 0 when unchecked
                }));
                return prev.filter(v => v !== value);
            } else {
                // User checked - add to selected
                setUserCheckboxStates(prevStates => ({
                    ...prevStates,
                    [value]: 1 // Set to 1 when checked
                }));
                return [...prev, value];
            }
        });
        // Update asterisk for UserList validation
        const newSelectedUsers = selectedUsers.includes(value)
            ? selectedUsers.filter(v => v !== value)
            : [...selectedUsers, value];

        if (newSelectedUsers.length > 0) {
            setShowAsterisks(prev => ({ ...prev, UserList: false }));
        }
    };

    const resetForm = () => {
        // Reset form data
        setFormData({
            EMTPL_Status: 0,
            EMTPL_EmailEventId: '',
            EMTPL_Subject: ''  // Make sure to reset subject
        });

        // Reset all selection states
        setDisabled(false);
        setKeyWords({});
        setErrMsg({});
        setEmailBody(''); // Clear CKEditor content

        // Reset SCP/Selection states
        setFilteredScpNames([]);
        setSelectedScpName('');
        setShowAsterisks({}); // Clear all asterisks

        // Reset Event related states
        setSelectedEvent('');
        setselectedevent('');

        // Reset Transmission Mode
        setSelectedTransmission("");

        // Reset From SCP states (for admin)
        setSelectedFromScpId("");
        setSelectedFromScpName("");
        setSelectedFromScpLevelNo("");

        // Reset Shipment Type
        setSelectedShipmentType('');
        setSelectedShipmentTypename('');

        // Reset User List-related states
        setSelectedUsers([]);
        setNewlyAddedUsers([]);
        setModalTempList([]);
        setShowModal(false);
        setEditingId(null);
        setNewUserContact('');

        // Reset SCP options and checkbox states
        setScpOptions([]);
        setUserCheckboxStates({});

        // Reset phone input defaults
        setSelectedCountry('in');
        setSelectedDialCode('91');

        // Close any open modals
        setShowDeleteModal(false);
        setUserToDelete(null);
        setOpenModal(false);
        setEmailModal(false);

        // Reset the form elements
        document.getElementById('form').reset();

        // If admin, also clear the From dropdown selection
        if (isAdmin) {
            // This is handled by setSelectedFromScpId above
        }

        logAction('Form has been reset to initial state');
    };

    const validateForm = () => {
        const asterisks = {};

        if (isAdmin) {
            if (!selectedFromScpId || selectedFromScpId === '') {
                asterisks.selectedfromscp = true;
                logAction('Validation error: selectedFromScpId is required');
            }
        }

        if (!parseInt(selectedTransmission)) {
            asterisks.transmissionMode = true;
            logAction('Validation error: EMTPL_EmailEventId is required');
        }

        if (!formData.EMTPL_EmailEventId || formData.EMTPL_EmailEventId === '') {
            asterisks.EMTPL_EmailEventId = true;
            logAction('Validation error: EMTPL_EmailEventId is required');
        }

        // Email Subject validation - ONLY for Email transmission (mode 1)
        if (parseInt(selectedTransmission) === 1) {
            if (!formData.EMTPL_Subject || formData.EMTPL_Subject.trim() === '') {
                asterisks.EMTPL_Subject = true;
                logAction('Validation error: EMTPL_Subject is required');
            }
        }

        if (!selectedScpName) {
            asterisks.selectedScpName = true;
            logAction('Validation error: selectedScpName is required');
        }

        if (formData.EMTPL_EmailEventId === 2 || formData.EMTPL_EmailEventId === 3) {
            if (!selectedShipmentType || selectedShipmentType === '0') {
                asterisks.selectedShipmentType = true;
                logAction('Validation error: selectedShipmentType is required for non-event 1');
            }
        }

        // Email/SMS Template validation
        const strippedContent = emailBody.replace(/<[^>]*>/g, '').trim();
        console.log("selectedTransmission", selectedTransmission, "strippedContent", strippedContent);
        if ((!strippedContent || strippedContent === '') && selectedTransmission !== "") {
            asterisks.emailBody = true;
            logAction('Validation error: emailBody is required and cannot be empty');
        }

        if ((!selectedUsers || selectedUsers.length === 0) && selectedTransmission !== "") {
            asterisks.UserList = true;
            logAction('Validation error: At least one user must be selected');
        }

        setShowAsterisks(asterisks);  // Update state to show asterisks ONLY during validation

        // Check if there are any asterisks (validation errors)
        const isValid = Object.keys(asterisks).length === 0;
        logAction(`Form validation result: ${isValid}`);
        return isValid;
    };
    const [isSubmitted, setIsSubmitted] = useState(false);

    const renderLabel = (field, label) => {
        const shouldShowAsterisk =
            showAsterisks[field] &&
            (
                field !== "emailBody" ||  // for all other fields → normal behavior
                parseInt(selectedTransmission) > 0 || isSubmitted

                // for emailBody → only if transmission selected
            );

        return (
            <label className="label1">
                {label}
                {shouldShowAsterisk && (
                    <span className="text-danger">*</span>
                )}
            </label>
        );
    };


    // Function to strip HTML tags
    const stripHtmlTags = (str) => {
        return str.replace(/<\/?[^>]+(>|$)/g, "");
    };


    //submit form 
    const submitForm = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);
        setLoading(true);

        // Get ONLY existing users (from API fetch) that are checked - for emailtemplateuserlist
        console.log("selectedUsers", selectedUsers);
        console.log("newlyAddedUsers", newlyAddedUsers);
        console.log("userCheckboxStates", userCheckboxStates);
        const existingUsersWithState = selectedUsers
            .filter(userId =>
                !newlyAddedUsers.some(
                    newUser => newUser.value?.toString().toLowerCase() === userId?.toString().toLowerCase()
                )
            )
            .map(userId => {
                const user = scpOptions.find(u => u.value === userId);
                return {
                    userId: userId, // This goes to emailtemplateuserlist
                    userData: user ? (
                        parseInt(selectedTransmission) === 2
                            ? user.phone || "No phone"
                            : user.email || "No email"
                    ) : userId,
                    isSelected: userCheckboxStates[userId] || 0
                };
            });

        console.log("✅ Existing Users for emailtemplateuserlist:", existingUsersWithState.map(u => u.userId));

        // Get ONLY newly added users (from modal) - for emailtemplatedetails
        let newlyAddedUsersWithState = [];
        if (newlyAddedUsers.length > 0) {
            newlyAddedUsersWithState = newlyAddedUsers.map((user) => {
                const userData = parseInt(selectedTransmission) === 2
                    ? user.phone || "No phone"
                    : user.email || "No email";

                return {
                    userData: userData,
                    isSelected: userCheckboxStates[user.value] ?? 1 // Default to checked for new users
                };
            });
        }

        console.log("🆕 Newly Added Users for emailtemplatedetails:", newlyAddedUsersWithState);

        const isValid = validateForm();
        if (!isValid) {
            logAction('Form validation failed, submission aborted.');
            setLoading(false);
            return;
        }

        const form = document.getElementById("form");
        const formObject = new FormData(form);
        const now = new Date();
        const formattedNow = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;

        formObject.append("EMTPL_Body", emailBody);
        formObject.append("EMTPL_CompanyID", UM_CompanyID);
        formObject.append("EMTPL_CompanyGrpID", UM_CompanyGrpID);
        formObject.append("EMTPL_FROMSCPID", isAdmin ? selectedFromScpId : selectedScpId);
        formObject.append("EMTPL_CreatedTimestamp", formattedNow);
        formObject.append("EMTPL_CreatedBy", UM_UserId);
        formObject.append("EMTPL_Status", formData.EMTPL_Status);
        formObject.append("EMTPL_TOSCPID", selectedScpName);
        formObject.append("EMTPL_EmailEventId", formData.EMTPL_EmailEventId);

        // CRITICAL: Send only existing user IDs for emailtemplateuserlist
        const existingUserIds = existingUsersWithState.map(u => u.userId);
        formObject.append("ETUL_UserID", existingUserIds.join(','));

        // CRITICAL: Send only newly added users for emailtemplatedetails
        formObject.append(
            "EMPTL_TemplateDetails",
            newlyAddedUsersWithState.length > 0
                ? JSON.stringify(newlyAddedUsersWithState, null, 2)
                : "{}"
        );

        formObject.append("EMTPL_TransmissionID", parseInt(selectedTransmission));

        if (formData.EMTPL_EmailEventId !== 1 && formData.EMTPL_EmailEventId !== 4) {
            formObject.append("EMTPL_SHPTTYPE", selectedShipmentType);
        }

        const formDataJson = Object.fromEntries(formObject.entries());
        console.log("Form Data to Send:", {
            ...formDataJson,
            ETUL_UserID: existingUserIds,
            EMPTL_TemplateDetails: newlyAddedUsersWithState
        });

        const selectedShipmentTypeOption = shipmentTypeOptions.find(option => option.value === parseInt(selectedShipmentType));
        const shipmenttypeName = selectedShipmentTypeOption ? selectedShipmentTypeOption.label : '';

        // Prepare clean data for audit log
        const stripHtmlTags = (str) => {
            return str.replace(/<\/?[^>]+(>|$)/g, "");
        };

        const escapeHtml = (unsafe) => {
            return unsafe
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
        };

        const cleanEmailBody = stripHtmlTags(emailBody);
        const safeSubject = parseInt(selectedTransmission) === 1
            ? escapeHtml(formData?.EMTPL_Subject || '')
            : formData?.EMTPL_Subject || '';

        try {
            logAction(`Executing API : ${config.API_URL}/api/email`);
            const response = await fetch(`${config.API_URL}/api/email`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formDataJson),
            });

            if (!response.ok) {
                logAction(`Error in Executing API : ${config.API_URL}/api/email`, true);
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            // Prepare transaction details for audit log
            const transactionDetails = [
                {
                    AUTRN_OldValue: "-",
                    AUTRN_NewValue: selectedFromScpName,
                    AUTRN_ParamererName: "From"
                },
                {
                    AUTRN_OldValue: "-",
                    AUTRN_NewValue: selectedevent,
                    AUTRN_ParamererName: "Email Event"
                },
                ...(selectedEvent !== 1 && selectedEvent !== 4 ? [{
                    AUTRN_OldValue: "-",
                    AUTRN_NewValue: selectedShipmentTypename,
                    AUTRN_ParamererName: "Shipment Type"
                }] : []),
                ...(parseInt(selectedTransmission) !== 2 ? [{
                    AUTRN_OldValue: "-",
                    AUTRN_NewValue: safeSubject,
                    AUTRN_ParamererName: "Email Subject"
                }] : []),
                {
                    AUTRN_OldValue: "-",
                    AUTRN_NewValue: `${selectedtoscp}`,
                    AUTRN_ParamererName: "To"
                },
                {
                    AUTRN_OldValue: "-",
                    AUTRN_NewValue: parseInt(formData.EMTPL_Status) === 0 ? "Active" : "Inactive",
                    AUTRN_ParamererName: "Status"
                },
                {
                    AUTRN_OldValue: "-",
                    AUTRN_NewValue: cleanEmailBody,
                    AUTRN_ParamererName: "Email Template"
                },
                {
                    AUTRN_OldValue: "-",
                    AUTRN_NewValue: `Existing Users: ${existingUserIds.length}, New Users: ${newlyAddedUsersWithState.length}`,
                    AUTRN_ParamererName: "Users Configuration"
                }
            ];

            // Log audit based on event type
            if (parseInt(formData.EMTPL_EmailEventId) === 1) {
                logAudit(
                    "Message Configuration",
                    `Message Configuration for Event Type : Order saved successfully`,
                    '-',
                    'Order',
                    transactionDetails
                );
                showToast('success', `Message Configuration for Event Type : Order Creation saved successfully.`, {
                    autoClose: 2000,
                    onClose: () => {
                        resetForm();
                        setLoading(false);
                    },
                });
            }
            else if (parseInt(formData.EMTPL_EmailEventId) === 6) {
                logAudit(
                    "Message Configuration",
                    `Message Configuration for Event Type : Order Updation saved successfully`,
                    '-',
                    'Scheme',
                    transactionDetails
                );
                showToast('success', `Message Configuration for Event Type : Order Updation saved successfully.`, {
                    autoClose: 2000,
                    onClose: () => {
                        resetForm();
                        setLoading(false);
                    },
                });
            }
            else if (parseInt(formData.EMTPL_EmailEventId) === 4) {
                logAudit(
                    "Message Configuration",
                    `Message Configuration for Event Type : Scheme saved successfully`,
                    '-',
                    'Scheme',
                    transactionDetails
                );
                showToast('success', `Message Configuration for Event Type : Scheme saved successfully.`, {
                    autoClose: 2000,
                    onClose: () => {
                        resetForm();
                        setLoading(false);
                    },
                });
            }
            else if (parseInt(formData.EMTPL_EmailEventId) === 2) {
                logAudit(
                    "Message Configuration",
                    `Message Configuration for Event Type : Shipment ${shipmenttypeName} saved successfully`,
                    '-',
                    `Shipment ${shipmenttypeName}`,
                    transactionDetails
                );
                showToast('success', `Message Configuration for Event Type : Shipment ${shipmenttypeName} saved successfully.`, {
                    autoClose: 1000,
                    onClose: () => {
                        resetForm();
                        setLoading(false);
                    },
                });
            }
            else if (parseInt(formData.EMTPL_EmailEventId) === 3) {
                logAudit(
                    "Message Configuration",
                    `Message Configuration for Event Type : Shipment Return ${shipmenttypeName} saved successfully`,
                    '-',
                    `Shipment Return ${shipmenttypeName}`,
                    transactionDetails
                );
                showToast('success', `Message Configuration for Event Type : Shipment Return ${shipmenttypeName} saved successfully.`, {
                    autoClose: 2000,
                    onClose: () => {
                        resetForm();
                        setLoading(false);
                    },
                });
            }
            else {
                // Generic success for other event types
                logAudit(
                    "Message Configuration",
                    `Message Configuration saved successfully`,
                    '-',
                    'Message Configuration',
                    transactionDetails
                );
                showToast('success', 'Message Configuration saved successfully.', {
                    autoClose: 2000,
                    onClose: () => {
                        resetForm();
                        setLoading(false);
                    },
                });
            }

            logAction(`Form submitted successfully with Event Type ID: ${formData.EMTPL_EmailEventId}`);

        } catch (error) {
            console.error("❌ Error saving template:", error);
            logAction(`Error during form submission: ${error.message}`, true);

            // Log failed audit
            const errorTransactionDetails = [
                {
                    AUTRN_OldValue: "-",
                    AUTRN_NewValue: selectedFromScpName,
                    AUTRN_ParamererName: "From"
                },
                {
                    AUTRN_OldValue: "-",
                    AUTRN_NewValue: selectedevent,
                    AUTRN_ParamererName: "Email Event"
                }
            ];

            logAudit(
                "Message Configuration",
                `Failed to save Message Configuration: ${error.message}`,
                '-',
                'Failed',
                errorTransactionDetails
            );

            showToast('error', 'Failed to save template. Please try again.', {
                autoClose: 3000,
            });

            setLoading(false);
        }
    };

    const onCloseHandler = () => {

        setShowAsterisks({});
        setSelectedEvent(''); // Reset selected event name
        setFormData({ EMTPL_EmailEventId: '', EMTPL_Status: 0 }); // Reset form data
        resetForm();
        setLoading(false);

    };


    const eventDropdownOptions = eventOption.map(option => ({
        value: option.EEVM_EmailEventId,       // react-select value
        label: option.EEVM_EventName,        // react-select label
        disabled: option.disabled || false  // supports disabled items
    }));

    const clearToAndUserSelections = () => {
        setSelectedScpName('');     // Clear "To" SCP selection
        setSelectedUsers([]);       // Uncheck all users
        setNewlyAddedUsers([]);     // Clear newly added users
        setModalTempList([]);       // Clear modal temp entries if any
        logAction("🔄 Cleared 'To' SCP and user selections due to event/shipment type change.");
    };


    const handleEventChange = (selectedOption) => {
        console.log("selectedTransmission", selectedTransmission);
        const selectedEvent = selectedOption ? selectedOption.value : "";
        const selectedEventName = selectedOption ? selectedOption.label : "";

        setselectedevent(selectedEventName);
        clearToAndUserSelections();

        // 🔥 Clear FROM SCP dropdown when event changes
        setSelectedFromScpId(null);
        setSelectedFromScpName("");

        setSelectedScpName("");     // Also clear "TO SCP"
        setScpOptions([]);          // Clear users list tied to FROM SCP

        // Shipment type logic unchanged
        setSelectedShipmentType((prev) => {
            if (selectedEvent === 2 || selectedEvent === 3) {
                return prev !== "0" ? prev : "0";
            }
            return "0";
        });

        setFormData((prev) => ({
            ...prev,
            EMTPL_EmailEventId: selectedEvent,
            EMTPL_Status: prev.EMTPL_Status || 0
        }));

        setSelectedEvent(selectedEvent);
        setDisableScpDropdown(selectedEvent === "");

        setShowAsterisks((prev) => ({
            ...prev,
            EMTPL_EmailEventId: !selectedEvent
        }));

        logAction(`Email Event changed: ${selectedEventName} (ID: ${selectedEvent})`);
    };

    const handleShipmentTypeChange = (selectedOption) => {
        const newValue = selectedOption ? selectedOption.value : null;
        const newValuename = selectedOption ? selectedOption.label : null;

        setSelectedShipmentType(newValue);
        setSelectedShipmentTypename(newValuename);

        clearToAndUserSelections();

        setFormData((prev) => ({
            ...prev,
            GRPM_GroupStatus: newValue
        }));

        if (newValue === "" || newValue === null) {
            setShowAsterisks(prev => ({ ...prev, selectedShipmentType: true }));
            logAction("Shipment Type selection is empty, asterisk shown.");
        } else if (newValue === 1 || newValue === 2) {
            setShowAsterisks(prev => ({ ...prev, selectedShipmentType: false }));
            logAction(`Shipment Type changed: ${newValuename} (Value: ${newValue})`);
        }
    };

    const isToDropdownDisabled =
        !formData.EMTPL_EmailEventId || // Dropdown is disabled if EMTPL_EmailEventId is not set
        (
            (formData.EMTPL_EmailEventId === 2 || formData.EMTPL_EmailEventId === 3) && // If EMTPL_EmailEventId is 2 or 3
            (selectedShipmentType === '0') // and selectedShipmentType is '0', disable the dropdown
        ) ||
        (isAdmin && selectedFromScpId === ''); // If the user is an admin and selectedFromScpId is '', disable the dropdown

    const handleSelectChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : null;

        if (selectedId) {
            setSelectedFromScpId(selectedId);
            setSelectedFromScpName(selectedOption?.label || "");
            setShowAsterisks(prev => ({ ...prev, selectedfromscp: false }));
            // Clear all dependent selections
            setSelectedScpName('');
            setSelectedUsers([]);
            setNewlyAddedUsers([]);
            setScpOptions([]);
            setUserCheckboxStates({});
        } else {
            setSelectedFromScpId(null);
            setSelectedFromScpName('');
            setShowAsterisks(prev => ({ ...prev, selectedfromscp: true }));
            setSelectedScpName('');
        }
    };

    // Update the handleChangeBody function for Quill
    // const handleChangeBody = (content, delta, source, editor) => {
    //     // For Quill, the content comes directly as the first parameter
    //     const strippedContent = content.replace(/<[^>]*>/g, '').trim();

    //     setEmailBody(content);

    //     // Reset error message
    //     setErrMsg(prevErrMsg => ({
    //         ...prevErrMsg,
    //         emailBody: '',
    //     }));

    //     // Clear asterisk when user starts typing
    //     if (strippedContent && showAsterisks.emailBody) {
    //         setShowAsterisks(prevAsterisks => ({
    //             ...prevAsterisks,
    //             emailBody: false
    //         }));
    //         logAction(`Removed asterisk for emailBody as user started typing`);
    //     }
    // };

    const editorConfiguration = {

        toolbar: {
            items: [
                'heading',
                '|',
                'fontSize',
                'fontFamily',
                '|',
                'bold',
                'italic',
                'underline',
                'fontSize',
                'strikethrough',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'alignment',
                '|',
                'link',
                'blockQuote',
                '|',
                'undo',
                'redo'
            ]
        },

        list: {
            properties: {
                styles: true,
                startIndex: true,
                reversed: true
            }
        },
        fontSize: {
            options: [
                10,
                12,
                14,
                16,
                18,
                20,
                24,
                28,
                32
            ],
            supportAllValues: true,
            applyToAll: false   // 👈 important
        },

        heading: {
            options: [
                { model: 'paragraph', title: 'Normal' },
                { model: 'heading3', view: 'h3', title: 'Large' },
                { model: 'heading2', view: 'h2', title: 'Extra Large' },
                { model: 'heading1', view: 'h1', title: 'Huge' }
            ],
            supportAllValues: true
        },

        htmlSupport: {
            allow: [{ name: /.*/, styles: true, classes: true, attributes: true }]
        },

        removePlugins: ['Title', 'Markdown']

    };
    const telegramEditorConfiguration = {
        toolbar: ['bold', 'italic', 'link', '|', 'undo', 'redo'],
        link: {
            addTargetToExternalLinks: true,
        },
        removePlugins: [
            'Heading',
            'List',
            'BlockQuote',
            'Indent',
            'Alignment',
            'Image',
            'Table',
            'MediaEmbed',
            'CKFinder', // ✅ Add this line
        ],
        readOnly: false,
    };
    const handleChangeBody = (event, editor) => {
        const content = editor.getData();
        const strippedContent = content.replace(/<[^>]*>/g, '').trim();

        setEmailBody(content);

        // Reset error message
        setErrMsg(prevErrMsg => ({
            ...prevErrMsg,
            emailBody: '',
        }));

        // Clear asterisk when user starts typing
        // If there's content and asterisk was showing, remove it
        if (strippedContent && showAsterisks.emailBody) {
            setShowAsterisks(prevAsterisks => ({
                ...prevAsterisks,
                emailBody: false
            }));
            logAction(`Removed asterisk for emailBody as user started typing`);
        }
    };
    // const quillModules = {
    //     toolbar: [
    //         [
    //             { size: ['small', false, 'large', 'huge'] } // Small, Normal, Large, Huge
    //         ],
    //         ['bold', 'italic', 'underline'], // underline next to italic ✅
    //         [{ list: 'ordered' }, { list: 'bullet' }],
    //         [{ align: [] }],
    //         ['link'],
    //         ['undo', 'redo']
    //     ],
    //     history: {
    //         delay: 500,
    //         maxStack: 100,
    //         userOnly: true
    //     }
    // };

    const quillModules = {
        toolbar: [
            // [{ header: [1, 2, 3, false] }],
            [{ size: ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'align': [] }],
            ['link', 'image', 'video'],
            ['clean']
        ]
    };
    const quillFormats = [
        'header',
        'size',
        'bold',
        'italic',
        'underline',
        'list',
        'align',
        'link'
    ];

    const scpDropdownOptions = scpData.map(scp => ({
        value: scp.SCPM_ID,
        label: scp.SCPM_Name
    }));

    const handleStatusChange = (selectedOption) => {
        const value = selectedOption ? selectedOption.value : "0";
        const field = "EMTPL_Status";

        setEmailList(value);

        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        setErrMsg(prev => ({
            ...prev,
            [field]: ""
        }));

        logAction(`Status changed: ${value}`);
    };

    // Update the handleAddToTempList function with all the fixes
    const handleAddToTempList = () => {
        const trimmed = (newUserContact || "").trim();

        // ============================================================
        // -------------------- BUG 1: ASTERISK ON BLANK --------------
        // ============================================================
        if (!trimmed) {
            setShowInputAsterisk(true);
            // showToast('error', 'Email Address is required.');
            return;
        }

        let formattedValue = trimmed;

        if (parseInt(selectedTransmission) === 2) {
            // Phone validation logic (unchanged)
            const dialCode = selectedDialCode;
            const maxLength = phoneLengthMapping[dialCode] || 10;
            let digits = trimmed.replace(/\D/g, "");

            if (digits.startsWith(dialCode)) {
                digits = digits.slice(dialCode.length);
            }

            const local = digits.slice(0, maxLength);

            if (local.startsWith("0")) {
                showToast('error', "Phone number cannot start with 0.");
                return;
            }

            if (local.length !== maxLength) {
                showToast('error', `Phone number must be exactly ${maxLength} digits.`);
                return;
            }

            formattedValue = `+${dialCode} ${local}`;
        } else {
            // ============================================================
            // ------------ BUG 4: CONVERT CAPS TO SMALL LETTERS ---------
            // ============================================================
            formattedValue = trimmed.toLowerCase();

            // ============================================================
            // ---------- BUG 2: TOAST FOR INVALID EMAIL FORMAT ----------
            // ============================================================
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formattedValue)) {
                showToast('error', "Please enter a valid email address.");
                return;
            }
        }

        // ============================================================
        // -------------------- EDIT MODE -----------------------------
        // ============================================================
        if (editingId !== null) {
            // Validate input
            if (!trimmed) {
                setShowInputAsterisk(true);
                return;
            }

            let formattedValue = trimmed;

            if (parseInt(selectedTransmission) === 2) {
                // Phone validation
                const dialCode = selectedDialCode;
                const maxLength = phoneLengthMapping[dialCode] || 10;
                let digits = trimmed.replace(/\D/g, "");

                if (digits.startsWith(dialCode)) {
                    digits = digits.slice(dialCode.length);
                }

                const local = digits.slice(0, maxLength);

                if (local.startsWith("0")) {
                    showToast('error', "Phone number cannot start with 0.");
                    return;
                }

                if (local.length !== maxLength) {
                    showToast('error', `Phone number must be exactly ${maxLength} digits.`);
                    return;
                }

                formattedValue = `+${dialCode} ${local}`;
            } else {
                // Email validation
                formattedValue = trimmed.toLowerCase();
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(formattedValue)) {
                    showToast('error', "Please enter a valid email address.");
                    return;
                }
            }

            // Check for duplicates (excluding self)
            const duplicateCheck = scpOptions.some((u) => {
                if (u.value === editingId) return false; // Skip self

                if (parseInt(selectedTransmission) === 2) {
                    return u.phone === formattedValue;
                } else {
                    return u.email?.trim().toLowerCase() === formattedValue.trim().toLowerCase();
                }
            });

            if (duplicateCheck) {
                showToast('error',
                    parseInt(selectedTransmission) === 2
                        ? "Phone Number already exists."
                        : "Email Address already exists."
                );
                return;
            }

            // Update modalTempList - add the edited item back as a temp entry
            // First, remove the old temp entry if exists
            const updatedTempList = modalTempList.filter(item => item.id !== editingId);

            // Add new temp entry
            const newTemp = {
                id: editingId, // Keep the same ID
                display: formattedValue,
                raw: formattedValue,
            };

            setModalTempList([...updatedTempList, newTemp]);

            // Update scpOptions to reflect the change
            setScpOptions((prev) =>
                prev.map((u) =>
                    u.value === editingId
                        ? {
                            ...u,
                            phone: parseInt(selectedTransmission) === 2 ? formattedValue : u.phone,
                            email: parseInt(selectedTransmission) === 2 ? u.email : formattedValue,
                            label: u.label, // Keep existing label
                            checked: true,
                        }
                        : u
                )
            );

            // Update newlyAddedUsers
            setNewlyAddedUsers((prev) =>
                prev.map((nu) =>
                    nu.value === editingId
                        ? {
                            ...nu,
                            phone: parseInt(selectedTransmission) === 2 ? formattedValue : "",
                            email: parseInt(selectedTransmission) === 2 ? "" : formattedValue,
                            label: nu.label, // Keep existing label
                        }
                        : nu
                ).filter(Boolean)
            );

            // Reset edit mode but KEEP MODAL OPEN
            setEditingId(null);

            // Reset input field based on transmission mode
            if (parseInt(selectedTransmission) === 2) {
                setSelectedDialCode("91");
                setNewUserContact("+91");
                setSelectedCountry("in");
            } else {
                setNewUserContact("");
                setSelectedDialCode("");
            }

            setShowInputAsterisk(false);

            // Show success message but DON'T close modal
            // showToast('success', 'User updated successfully. Click SAVE to confirm changes.');

            return;
        }
        // ============================================================
        // -------------------- ADD MODE ------------------------------
        // ============================================================
        // ============================================================
        // ----------- BUG 7 & 8: DUPLICATE EMAIL CHECK ----------------
        // ============================================================
        const duplicate = scpOptions.some((u) => {
            if (parseInt(selectedTransmission) === 2) {
                return u.phone === formattedValue;
            } else {
                return u.email?.trim().toLowerCase() === formattedValue.trim().toLowerCase();
            }
        });

        if (duplicate) {
            showToast('error',
                parseInt(selectedTransmission) === 2
                    ? "Phone Number already exists."
                    : "Email Address already exists."
            );
            return;
        }

        // Also check temp list for duplicates
        const tempDuplicate = modalTempList.some((item) => {
            if (parseInt(selectedTransmission) === 2) {
                return item.raw === formattedValue;
            } else {
                return item.raw?.trim().toLowerCase() === formattedValue.trim().toLowerCase();
            }
        });

        if (tempDuplicate) {
            showToast('error',
                parseInt(selectedTransmission) === 2
                    ? "Phone Number already exists."
                    : "Email Address already exists."
            );
            return;
        }

        const newTemp = {
            id: `temp-${Date.now()}`,
            display: formattedValue,
            raw: formattedValue,
        };

        setModalTempList((prev) => [...prev, newTemp]);

        // Reset input field
        if (parseInt(selectedTransmission) === 2) {
            setNewUserContact("+91");
            setSelectedCountry("in");
        } else {
            setNewUserContact("");
        }

        setShowInputAsterisk(false);
    };

    // ============================================================
    // ------------ BUG 3: ENTER KEY PRESS HANDLER ----------------
    // ============================================================
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent form submission
            handleAddToTempList(); // Add the item
        }
    };
    const handleEditTemp = (id) => {
        const entry = modalTempList.find((item) => item.id === id);
        if (!entry) return;

        setEditingId(id);

        // Extract just the number for phone input
        if (parseInt(selectedTransmission) === 2 && entry.raw) {
            // Remove country code prefix like "+91 "
            const phoneWithoutPrefix = entry.raw.replace(/^\+\d+\s*/, '');
            setNewUserContact(phoneWithoutPrefix);

            // Extract country code
            const match = entry.raw.match(/^\+\d+/);
            if (match) {
                const dialCode = match[0].replace('+', '');
                setSelectedDialCode(dialCode);

                // Find country from allowedCountries
                const country = allowedCountries.find(countryCode => {
                    // This is a simplified mapping - you might need a proper mapping
                    return dialCode === "91" ? countryCode === "in" :
                        dialCode === "93" ? countryCode === "af" :
                            // Add more mappings as needed
                            countryCode;
                });
                if (country) setSelectedCountry(country);
            }
        } else {
            setNewUserContact(entry.raw);
        }

        setShowInputAsterisk(false);
    };
    const handleRemoveFromTemp = (id) => {
        setModalTempList((prev) => prev.filter((p) => p.id !== id));
        if (editingId === id) {
            setEditingId(null);
            if (parseInt(selectedTransmission) === 2) {
                setNewUserContact("+91");
                setSelectedCountry("in");
            } else {
                setNewUserContact("");
            }

        }
    };

    const getMaxAddedUserNumber = (list) => {
        return list.reduce((max, u) => {
            const match = u.label?.match(/Added User-(\d+)/);
            return match ? Math.max(max, parseInt(match[1], 10)) : max;
        }, 0);
    };

    const handleSaveFromModal = () => {
        if (editingId !== null) {
            showToast('error', ' At least one Email is required to save the User Details.');
            return;
        }

        if (modalTempList.length === 0) {
            // setShowInputAsterisk(true);
            // showToast('error', ' At least one Email is required to save the User Details.');
            showToast('error',
                parseInt(selectedTransmission) === 2
                    ? " At least one Contact is required to save the User Details."
                    : " At least one Email is required to save the User Details."
            );
            return;
        }

        // 🔑 Get max existing number ONCE
        let nextUserNumber = getMaxAddedUserNumber(scpOptions);

        const newUsers = modalTempList.map((item) => {
            const isNew = item.id.startsWith('temp-');

            if (isNew) nextUserNumber += 1;

            const userLabel = isNew
                ? `Added User-${nextUserNumber}`
                : scpOptions.find(u => u.value === item.id)?.label;

            const userId = isNew ? `added-user-${nextUserNumber}` : item.id;

            // Initialize checkbox state to 1 (checked) when added
            setUserCheckboxStates(prev => ({
                ...prev,
                [userId]: 1
            }));

            return {
                value: userId,
                label: userLabel,
                phone: parseInt(selectedTransmission) === 2 ? item.raw : '',
                email: parseInt(selectedTransmission) === 2 ? '' : item.raw,
                flag: 1,
                checked: true,
                isSelected: 1 // Add isSelected flag
            };
        });

        // 🔄 Replace edited + add new
        setScpOptions(prev => {
            const tempIds = modalTempList.map(i => i.id);
            const filtered = prev.filter(u => !tempIds.includes(u.value));
            return [...filtered, ...newUsers];
        });

        setNewlyAddedUsers(prev => {
            const tempIds = modalTempList.map(i => i.id);
            const filtered = prev.filter(u => !tempIds.includes(u.value));
            return [...filtered, ...newUsers];
        });

        setSelectedUsers(prev =>
            [...new Set([...prev, ...newUsers.map(u => u.value)])]
        );

        // 🔚 Cleanup
        setShowModal(false);
        setModalTempList([]);
        setNewUserContact('');
        setShowInputAsterisk(false);
        setEditingId(null);

        showToast('success', 'Users added and selected successfully.');
    };
    const handleCopyPlain = (e) => {
        e.preventDefault();

        // Get only keyword <td> elements that are selected
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const container = range.cloneContents();

        // Find only the TDs for keywords
        const keywordCells = container.querySelectorAll('td.keyword-cell');

        // NEW: Extract and format keyword-description pairs
        let formattedText = '';

        // Create pairs of keywords and descriptions
        for (let i = 0; i < keywordCells.length; i += 2) {
            const keyword = keywordCells[i]?.innerText?.trim() || '';
            const description = keywordCells[i + 1]?.innerText?.trim() || '';

            if (keyword && description) {
                // Format as "keyword : description"
                formattedText += `${keyword} : ${description}\n`;
            }
        }

        // If no formatted text (maybe selection wasn't proper), fall back to old method
        if (!formattedText.trim()) {
            formattedText = Array.from(keywordCells).map(td => td.innerText).join('\n');
        }

        e.clipboardData.setData("text/plain", formattedText.trim());
    };

    const hideEmailSetting = () => {
        setEmailModal(false);
    };


    const statusDropdownOptions = statusOption.map(option => ({
        value: option.EnumVal,
        label: option.Description
    }));

    // Helper function for dropdown open/close
    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };

    return (
        <>
            {loading && (
                <div
                    style={{
                        position: 'fixed',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 1000,
                    }}
                />
            )}


            <ToastContainer
                style={{
                    marginTop: '73px',
                    fontSize: '14px',
                    width: '40%',
                }}
            />


            <div className="main_container">
                <div className="orderHeader d-flex align-items-center justify-content-between">
                    <h1 className="formHeading" style={{marginLeft:'5px'}}>Message Configuration</h1>


                    {selectedTransmission && (
                        <div className="d-flex align-items-center gap-3">

                            <FaTags
                                size={22}
                                style={{ cursor: 'pointer' }}
                                title="Event Type Keywords"
                                onClick={showKeyWords}
                            />


                            {Number(parseInt(selectedTransmission)) === 1 && (
                                <FaCog
                                    size={22}
                                    style={{ cursor: 'pointer' }}
                                    title="Email Setting"
                                    onClick={emailSetting}
                                />
                            )}
                        </div>
                    )}
                </div>

                <form id="form" autoComplete="off">
                    {/* First Row */}
                    <div className="row" style={{ marginLeft: '-6px' }}>
                        {/* Transmission Mode */}
                        <div className="col-md-3 mb-4">
                            {renderLabel('transmissionMode', 'Transmission Mode')}
                            {/* <div className="d-grid"> */}
                            <div className="select-container">
                                <Select
                                    key={selectedTransmission}
                                    className="routing_select-box"
                                    classNamePrefix="react-select"
                                    style={{ width: '100%' }}
                                    options={transmissionOptions}
                                    value={transmissionOptions.find(option => option.value === selectedTransmission)}
                                    onChange={(selectedOption) => {
                                        const val = selectedOption ? selectedOption.value : "";
                                        setSelectedTransmission(val);
                                        console.log("selectedTransmission", selectedTransmission);
                                        if (val !== "") {
                                            setShowAsterisks((prev) => ({
                                                ...prev,
                                                transmissionMode: false,
                                            }));
                                        }
                                    }}
                                    placeholder="--Select--"
                                    isDisabled={false}
                                    onMenuOpen={() => handleSelectOpen("transmissionMode")}
                                    onMenuClose={handleSelectClose}
                                    components={{ SingleValue: CustomSingleValue }}
                                />
                                <div className="icon-container_list myList">
                                    {isSelectOpen === "transmissionMode" ? (
                                        <IoCaretUpOutline />
                                    ) : (
                                        <IoCaretDownOutline />
                                    )}
                                </div>
                            </div>
                            {/* </div> */}
                        </div>

                        {/* Event Type */}
                        <div className="col-md-3">
                            {renderLabel('EMTPL_EmailEventId', 'Event Type')}
                            <div className="select-container" id="event">
                                <Select
                                    key={formData.EMTPL_EmailEventId}
                                    name="EMTPL_EmailEventId"
                                    placeholder="--Select--"
                                    className="routing_select-box"
                                    classNamePrefix="react-select"
                                    options={eventDropdownOptions}
                                    isDisabled={disableField}
                                    value={eventDropdownOptions.find(option => option.value === formData.EMTPL_EmailEventId)}
                                    onChange={handleEventChange}
                                    onMenuOpen={() => handleSelectOpen("EMTPL_EmailEventId")}
                                    onMenuClose={handleSelectClose}
                                    maxMenuHeight={150}
                                    components={{ SingleValue: CustomSingleValue }}

                                />
                                <div className="icon-container_list myList">
                                    {isSelectOpen === "EMTPL_EmailEventId" ? (
                                        <IoCaretUpOutline />
                                    ) : (
                                        <IoCaretDownOutline />
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* From */}
                        <div className="col-md-3 mb-4">
                            {renderLabel('selectedfromscp', 'From')}
                            {/* <div className="d-grid"> */}
                            {isAdmin ? (
                                <div className="select-container_list">
                                    <Select
                                        key={selectedFromScpId}
                                        name="scpName"
                                        placeholder="--Select--"
                                        className="routing_select-box"
                                        classNamePrefix="react-select"
                                        options={scpDropdownOptions}
                                        value={scpDropdownOptions.find(option => option.value === selectedFromScpId)}
                                        onChange={handleSelectChange}
                                        isDisabled={false}
                                        onMenuOpen={() => handleSelectOpen("scpName")}
                                        onMenuClose={handleSelectClose}
                                        maxMenuHeight={150}
                                        components={{ SingleValue: CustomSingleValue }}
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: '#cfcfcf',
                                                },
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                maxWidth: '100%',
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'unset', // 🔥 important
                                                color: '#465a64', // 🔥 important
                                            }),
                                        }}
                                    />
                                    <div className="icon-container_list myList">
                                        {isSelectOpen === "scpName" ? (
                                            <IoCaretUpOutline />
                                        ) : (
                                            <IoCaretDownOutline />
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <input
                                    type="text"
                                    id="scpName"
                                    value={selectedFromScpName}
                                    readOnly
                                    className="form-input"
                                    style={{
                                        backgroundColor: '#f2f2f2',
                                        color: '#6c757d',
                                    }}
                                />
                            )}
                            {/* </div> */}
                        </div>

                        {/* Shipment Type (only when EMTPL_EmailEventId is 2 or 3) */}
                        {(formData.EMTPL_EmailEventId === 2 || formData.EMTPL_EmailEventId === 3) && (
                            <div className="col-md-3" id="shipmenttype">
                                {renderLabel('selectedShipmentType', 'Shipment Type')}
                                <div className="select-container_list">
                                    <Select
                                        key={selectedShipmentType}
                                        name="selectedShipmentType"
                                        placeholder="--Select--"
                                        className="routing_select-box"
                                        classNamePrefix="react-select"
                                        options={shipmentTypeOptions}
                                        value={shipmentTypeOptions.find(option => option.value === parseInt(selectedShipmentType))}
                                        onChange={handleShipmentTypeChange}
                                        isDisabled={false}
                                        onMenuOpen={() => handleSelectOpen("selectedShipmentType")}
                                        onMenuClose={handleSelectClose}
                                        maxMenuHeight={150}
                                        components={{ SingleValue: CustomSingleValue }}
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: '#cfcfcf',
                                                },
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                maxWidth: '100%',
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'unset', // 🔥 important
                                                color: '#465a64', // 🔥 important
                                            }),
                                        }}

                                    />
                                    <div className="icon-container_list myList">
                                        {isSelectOpen === "selectedShipmentType" ? (
                                            <IoCaretUpOutline />
                                        ) : (
                                            <IoCaretDownOutline />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* To (only when EMTPL_EmailEventId is NOT 2) */}
                        {(formData.EMTPL_EmailEventId === 1 || formData.EMTPL_EmailEventId === 6 || formData.EMTPL_EmailEventId === 3 || formData.EMTPL_EmailEventId === '' || formData.EMTPL_EmailEventId === 4) && (
                            <div className="col-md-3 mb-4">
                                {renderLabel('selectedScpName', 'To')}
                                <strong style={{ display: 'none' }} id="tscp">
                                    *
                                </strong>
                                <div className="select-container_list">
                                    <Select
                                        key={selectedScpName}
                                        name="scpNameDropdown"
                                        placeholder="--Select--"
                                        className="routing_select-box"
                                        classNamePrefix="react-select"
                                        options={filteredScpNames}
                                        value={filteredScpNames.find(option => option.value === selectedScpName)}
                                        onChange={handleChangetoscp}
                                        isDisabled={isToDropdownDisabled}
                                        onMenuOpen={() => handleSelectOpen("scpNameDropdown")}
                                        onMenuClose={handleSelectClose}
                                        maxMenuHeight={150}
                                        components={{ SingleValue: CustomSingleValue }}
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: '#cfcfcf',
                                                },
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                maxWidth: '100%',
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'unset', // 🔥 important
                                                color: '#465a64', // 🔥 important
                                            }),
                                        }}
                                    />
                                    <div className="icon-container_list myList">
                                        {isSelectOpen === "scpNameDropdown" ? (
                                            <IoCaretUpOutline />
                                        ) : (
                                            <IoCaretDownOutline />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Second Row */}
                    <div className="row" style={{ marginLeft: '-6px' }}>
                        {/* To (only when EMTPL_EmailEventId is 2) */}
                        {(formData.EMTPL_EmailEventId === 2 || formData.EMTPL_EmailEventId === 3) && (
                            <div className="col-md-3 mb-4">
                                {renderLabel('selectedScpName', 'To')}
                                <strong style={{ display: 'none' }} id="tscp">
                                    *
                                </strong>
                                <div className="select-container_list">
                                    <Select
                                        key={selectedScpName}
                                        name="scpNameDropdown"
                                        placeholder="--Select--"
                                        className="routing_select-box"
                                        classNamePrefix="react-select"
                                        options={filteredScpNames}
                                        value={filteredScpNames.find(option => option.value === selectedScpName)}
                                        onChange={handleChangetoscp}
                                        isDisabled={isToDropdownDisabled}
                                        onMenuOpen={() => handleSelectOpen("scpNameDropdown")}
                                        onMenuClose={handleSelectClose}
                                        maxMenuHeight={150}
                                        components={{ SingleValue: CustomSingleValue }}
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: '#cfcfcf',
                                                },
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                maxWidth: '100%',
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'unset', // 🔥 important
                                                color: '#465a64', // 🔥 important
                                            }),
                                        }}
                                    />
                                    <div className="icon-container_list myList">
                                        {isSelectOpen === "scpNameDropdown" ? (
                                            <IoCaretUpOutline />
                                        ) : (
                                            <IoCaretDownOutline />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Users List (shown when selectedScpName is set) */}
                        {selectedScpName && (
                            <div
                                className="col-md-3 mb-3"
                                //  className={(formData.EMTPL_EmailEventId === 1) ? "col-md-6 mb-4" : "col-md-3 mb-4"} 
                                style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                                <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ marginBottom: "1px" }} // ✅ slightly increased for even baseline
                                >
                                    {renderLabel('UserList', "Users List")}
                                    <Button
                                        type="button"
                                        title="Add"
                                        onClick={() => setShowModal(true)}
                                        style={{
                                            backgroundColor: "#295a80",
                                            borderColor: "#295a80",
                                            color: "#fff",
                                            width: "26px",
                                            height: "25px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "0",
                                            lineHeight: "1",
                                            borderRadius: "5px",
                                            outline: "none",
                                            boxShadow: "none",
                                            cursor: "pointer",
                                        }}
                                        onFocus={(e) => e.target.blur()}
                                    >
                                        <FaPlus size={12} />
                                    </Button>
                                </div>

                                <div
                                    className="form-check border p-2 rounded"
                                    style={{
                                        marginTop: "0px",
                                        minHeight: "38px",

                                        // ⭐ FIX: Add scroll when content grows
                                        maxHeight: "250px",
                                        overflowY: "auto",

                                        display: "flex",
                                        flexDirection: "column",
                                        paddingRight: "6px", // Avoid hiding behind scrollbar
                                    }}
                                >

                                    {scpOptions.length === 0 ? (
                                        <div className="text-center py-3 text-muted">
                                            No Users
                                        </div>
                                    ) : (
                                        <>
                                            <div>
                                                {/* // In your JSX for Select All checkbox */}
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="select-all-users"
                                                    checked={selectedUsers.length === scpOptions.length && scpOptions.length > 0}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // ✅ Select all users
                                                            const allUsers = scpOptions.map((user) => user.value);
                                                            setSelectedUsers(allUsers);

                                                            // Set all checkbox states to 1
                                                            const allStates = {};
                                                            scpOptions.forEach(user => {
                                                                allStates[user.value] = 1;
                                                            });
                                                            setUserCheckboxStates(allStates);

                                                            setShowAsterisks((prev) => ({ ...prev, UserList: false }));
                                                        } else {
                                                            // ❌ Uncheck all users
                                                            setSelectedUsers([]);

                                                            // Set all checkbox states to 0
                                                            const allStates = {};
                                                            scpOptions.forEach(user => {
                                                                allStates[user.value] = 0;
                                                            });
                                                            setUserCheckboxStates(allStates);
                                                        }
                                                    }}
                                                />
                                                <label htmlFor="select-all-users" className="form-check-label fw-bold"
                                                >
                                                    Select All
                                                </label>

                                            </div>
                                            {scpOptions.map((user) => {
                                                const isAddedUser = newlyAddedUsers.some((u) => u.value === user.value);

                                                return (
                                                    <div
                                                        key={user.value}
                                                        className="d-flex justify-content-between py-1"
                                                        style={{
                                                            alignItems: "flex-start",   // ⭐ ensures label wraps without shifting checkbox
                                                            gap: "6px"
                                                        }}
                                                    >
                                                        <div className="d-flex" style={{ alignItems: "flex-start", flexGrow: 1 }}>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input me-2"
                                                                id={`user-${user.value}`}
                                                                value={user.value}
                                                                checked={selectedUsers.includes(user.value)}
                                                                onChange={() => handleSCPListChange(user.value)}
                                                                style={{ marginTop: "3px" }}   // align checkbox to top
                                                            />
                                                            <label
                                                                htmlFor={`user-${user.value}`}
                                                                className="form-check-label user-label mb-0"
                                                                style={{
                                                                    fontSize: "0.9rem",
                                                                    whiteSpace: "normal",
                                                                    wordBreak: "break-word",
                                                                    flexGrow: 1
                                                                }}
                                                            >
                                                                {user.label} (
                                                                {parseInt(selectedTransmission) === 2
                                                                    ? user.phone
                                                                    : user.email}
                                                                )
                                                            </label>
                                                        </div>

                                                        {/* show edit/delete icons only for added users */}
                                                        {isAddedUser && (
                                                            <div className="d-flex align-items-center gap-1">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary p-1 user-action-btn"
                                                                    title="Edit"
                                                                    style={{
                                                                        backgroundColor: "#295a80",
                                                                        borderColor: "#295a80",
                                                                        width: "26px",
                                                                        height: "26px",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        borderRadius: "4px",
                                                                    }}
                                                                    onClick={() => handleEditUser(user)}
                                                                >
                                                                    <FaEdit size={17} color="#fff" />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: "#295a80",
                                                                        borderColor: "#295a80",
                                                                        width: "26px",
                                                                        height: "26px",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        borderRadius: "4px",
                                                                    }}
                                                                    className="btn btn-sm btn-outline-secondary p-1 user-action-btn"
                                                                    title="Delete"
                                                                    onClick={() => handleDeleteUser(user.value)}
                                                                >
                                                                    <FaTrash size={14} color="#fff" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </>
                                    )}


                                </div>
                            </div>
                        )}

                        {/* Email Subject (only when Transmission Mode is 1) */}
                        {parseInt(selectedTransmission) === 1 && (
                            <div className="col-md-3">
                                {renderLabel('EMTPL_Subject', 'Email Subject')}
                                <input
                                    id="EMTPL_Subject"
                                    type="text"
                                    onChange={handleChange}
                                    name="EMTPL_Subject"
                                    value={formData.EMTPL_Subject}
                                    autoComplete="new-password"
                                    autofill="off"
                                    maxLength={1000}
                                    className="form-input"
                                />
                            </div>
                        )}

                        {/* Status */}
                        <div className="col-md-3">
                            <label className="">Status</label>
                            <span className="errMsg">{errMsg.status}</span>
                            <div className="select-container_list">
                                <Select
                                    name="EMTPL_Status"
                                    placeholder="Select Status"
                                    className="routing_select-box"
                                    classNamePrefix="react-select"
                                    options={statusDropdownOptions}
                                    value={statusDropdownOptions.find(option => option.value === formData.EMTPL_Status)}
                                    onChange={handleStatusChange}
                                    isDisabled={false}
                                    onMenuOpen={() => handleSelectOpen("EMTPL_Status")}
                                    onMenuClose={handleSelectClose}
                                    maxMenuHeight={150}
                                    isSearchable={false}
                                    components={{ SingleValue: CustomSingleValue }}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                                            boxShadow: 'none',
                                            '&:hover': {
                                                borderColor: '#cfcfcf',
                                            },
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            maxWidth: '100%',
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'unset', // 🔥 important
                                            color: '#465a64', // 🔥 important
                                        }),
                                    }}
                                />
                                <div className="icon-container_list myList">
                                    {isSelectOpen === "EMTPL_Status" ? (
                                        <IoCaretUpOutline />
                                    ) : (
                                        <IoCaretDownOutline />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Email/SMS Template */}
                    {/* <div className="field">
                        {renderLabel(
                            'emailBody',
                            parseInt(selectedTransmission) === 1
                                ? 'Email Template'
                                : parseInt(selectedTransmission) === 2
                                    ? 'Telegram Template'
                                    : ''
                        )}

                        {parseInt(selectedTransmission) === 1 || parseInt(selectedTransmission) === 2 ? (
                            <ReactQuill
                                theme="snow"
                                value={emailBody}
                                onChange={handleChangeBody}
                                modules={quillModules}
                                formats={quillFormats}
                                className="emailTemplate"
                                style={{
                                    height: '200px',
                                    marginBottom: '50px' // For toolbar spacing
                                }}
                            />
                        ) : null}
                    </div> */}
                    <div className="field" style={{ marginLeft: "6px" }}>
                        {parseInt(selectedTransmission) === 1 ? (
                            renderLabel(
                                'emailBody',
                                'Email Template')
                        )
                            : parseInt(selectedTransmission) === 2 && (
                                renderLabel(
                                    'emailBody',
                                    'Telegram Template')
                            )
                        }
                        {/* {renderLabel(
                            'emailBody',
                            parseInt(selectedTransmission) === 1
                                ? 'Email Template'
                                : parseInt(selectedTransmission) === 2
                                    ? 'Telegram Template'
                                    : ''
                        )} */}
                        {parseInt(selectedTransmission) === 2 ? (
                            <CKEditor
                                id="emailBody"
                                editor={ClassicEditor}
                                data={emailBody}
                                config={telegramEditorConfiguration}
                                onReady={(editor) => {
                                    const enterCommand = editor.commands.get('enter');
                                    const shiftEnterCommand = editor.commands.get('shiftEnter');

                                    editor.editing.view.document.on('enter', (evt, data) => {
                                        evt.stop();              // stop default Enter behavior
                                        editor.execute('shiftEnter');  // execute Shift+Enter instead
                                    });
                                }}
                                onChange={handleChangeBody}
                                className="emailTemplate"
                            />

                        ) : parseInt(selectedTransmission) === 1 ? (
                            <CKEditor
                                id="emailBody"
                                name="emailBody"
                                editor={ClassicEditor}
                                data={emailBody}
                                config={editorConfiguration}
                                // onReady={(editor) => {

                                //     editor.model.document.on('change:data', () => {

                                //         const selection = editor.model.document.selection;
                                //         const position = selection.getFirstPosition();
                                //         const parent = position.parent;

                                //         // If current block is paragraph
                                //         if (parent.is('element', 'paragraph')) {

                                //             const previousBlock = parent.previousSibling;

                                //             if (
                                //                 previousBlock &&
                                //                 previousBlock.is('element') &&
                                //                 previousBlock.name.startsWith('heading')
                                //             ) {
                                //                 editor.model.change(writer => {
                                //                     writer.rename(parent, previousBlock.name);
                                //                 });
                                //             }
                                //         }

                                //     });

                                // }}

                                // onReady={(editor) => {
                                //     const enterCommand = editor.commands.get('enter');
                                //     const shiftEnterCommand = editor.commands.get('shiftEnter');

                                //     editor.editing.view.document.on('enter', (evt, data) => {
                                //         evt.stop();              // stop default Enter behavior
                                //         editor.execute('shiftEnter');  // execute Shift+Enter instead
                                //     });
                                // }}

                                onReady={(editor) => {
                                    editor.editing.view.document.on('enter', (evt, data) => {
                                        const model = editor.model;
                                        const selection = model.document.selection;
                                        const block = selection.getFirstPosition().parent;

                                        // Check if current block has list attribute
                                        const isList = block.hasAttribute('listItemId') || block.hasAttribute('listType');

                                        if (!isList) {
                                            evt.stop();
                                            editor.execute('shiftEnter');
                                        }
                                    });
                                }}

                                onChange={handleChangeBody}
                                className="emailTemplate"
                            />
                        ) : null}
                    </div>
                </form>

                {/* Modals */}
                <Modal show={openModal} onHide={hideKeyWords} backdrop="static" centered keyboard={false}
                    style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)', color: "#465a64", }}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: '20px', fontWeight: 'bold' }}>
                            Event Keywords
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="table-responsive">
                            <table className="tableClass" onCopy={handleCopyPlain}>

                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Description</th>
                                        <th>Event Keyword</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(keyWords) && keyWords.length > 0 ? (
                                        keyWords.map((rowData, rowIdx) => (
                                            <tr key={rowIdx}>
                                                <td>{rowIdx + 1}</td>
                                                <td style={{ userSelect: 'text' }} className="keyword-cell">{rowData.EMKW_FindValue}</td>
                                                <td style={{ userSelect: 'text' }} className="keyword-cell">{rowData.EMKW_TagName}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: 'center', padding: '8px' }}>
                                                No Records Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                </Modal>


                {showDeleteModal && (
                    <div className="popup_overlay">
                        <div className="resetpopup">
                            {/* Header */}

                            <h1>:: User Confirmation ::</h1>

                            <h4>
                                Are you sure you want to remove this record ?
                            </h4>

                            {/* Footer */}
                            <div className="popup_btn_container">
                                <button
                                    onClick={confirmDeleteUser}
                                    className="yes_btn"
                                >
                                    YES
                                </button>
                                <button
                                    onClick={() => {
                                        setShowDeleteModal(false);
                                        setUserToDelete(null);
                                    }}
                                    className="no_btn"
                                >
                                    NO
                                </button>


                            </div>
                        </div>
                    </div>
                )}


                <Modal
                    size="md"
                    show={showModal}
                    onHide={() => {
                        setShowModal(false);
                        setModalTempList([]);
                        if (parseInt(selectedTransmission) === 2) {
                            setNewUserContact("+91");
                            setSelectedCountry("in");
                        } else {
                            setNewUserContact("");
                        }

                        setShowInputAsterisk(false);
                        setEditingId(null);
                    }}
                    centered
                    backdrop="static"
                    style={{ backdropFilter: "blur(3px)", backgroundColor: "rgba(0, 0, 0, 0.3)", color: "#465a64", }}
                >
                    <Modal.Header
                        closeButton={!editingId}
                    >
                        <Modal.Title style={{ fontSize: '20px', fontWeight: 'bold', color: '#465a64' }}>
                            {!editingId ? 'Add User Details' : 'Edit User Details'}
                        </Modal.Title>

                    </Modal.Header>

                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3" controlId="formNewUser">
                                <div className="d-flex align-items-center">
                                    <label
                                        htmlFor="formNewUser"
                                        className="form-label fw-semibold mb-0"
                                        style={{ display: "flex", alignItems: "center", gap: "4px" }}
                                    >
                                        {parseInt(selectedTransmission) === 1
                                            ? "Email Address"
                                            : parseInt(selectedTransmission) === 2
                                                ? "Phone Number"
                                                : "Contact"}
                                        {showInputAsterisk && (
                                            <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                        )}
                                    </label>
                                </div>
                                <InputGroup>
                                    <div
                                        className="d-flex align-items-center gap-2"
                                        style={{ width: "100%", flexWrap: "nowrap" }}
                                    >
                                        {parseInt(selectedTransmission) === 2 ? (
                                            // 📱 PHONE INPUT (for Telegram)
                                            <PhoneInput
                                                key={selectedCountry} // 🔑 re-render when country changes
                                                country={selectedCountry}
                                                onlyCountries={allowedCountries}
                                                value={newUserContact}
                                                onChange={(phone, countryData) => {
                                                    if (countryData) {
                                                        setSelectedCountry(countryData.countryCode);   // "in"
                                                        setSelectedDialCode(countryData.dialCode);     // "91"
                                                    }

                                                    setNewUserContact(phone);
                                                    if (phone.trim() !== "") setShowInputAsterisk(false);
                                                }}

                                                inputStyle={{
                                                    width: '87%',
                                                    borderRadius: '6px',
                                                    height: '38px',
                                                    borderColor: '#ced4da',
                                                }}
                                                buttonStyle={{
                                                    borderColor: '#ced4da',
                                                }}
                                                dropdownStyle={{
                                                    zIndex: 9999,
                                                }}
                                                countryCodeEditable={false}
                                                autoComplete="off"
                                            />

                                        ) : (
                                            // 📧 EMAIL INPUT (for Email transmission)
                                            <Form.Control
                                                type="email"
                                                value={newUserContact}
                                                autoComplete="new-password"
                                                onChange={(e) => {
                                                    // BUG 4: Convert to lowercase as user types
                                                    setNewUserContact(e.target.value.toLowerCase());
                                                    if (e.target.value.trim() !== "") setShowInputAsterisk(false);
                                                }}
                                                onKeyPress={handleKeyPress} // Add this line
                                                style={{
                                                    width: "87%",
                                                    borderRadius: "6px",
                                                    height: "38px",
                                                    borderColor: "#ced4da",
                                                    flexShrink: 0,
                                                }}
                                                maxLength={45}
                                            />
                                        )}

                                        {/* Buttons Section */}
                                        <div
                                            className="d-flex align-items-center gap-2"
                                            style={{ flexShrink: 0, marginLeft: "8px" }}
                                        >
                                            {!editingId ? (
                                                // ✅ ADD button
                                                <Button
                                                    id="add-user-btn"  // Add ID here
                                                    variant="outline-success"
                                                    onClick={handleAddToTempList}
                                                    title="Add"
                                                    style={{
                                                        backgroundColor: "#295a80",
                                                        borderColor: "#295a80",
                                                        color: "#fff",
                                                        minWidth: "38px",
                                                        height: "38px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        outline: "none",         // 🚫 removes outline on click
                                                        boxShadow: "none",       // 🚫 removes glow or focus shadow
                                                    }}
                                                    onFocus={(e) => e.target.blur()} // 🚫 immediately removes focus
                                                >
                                                    <FaPlus size={16} />
                                                </Button>

                                            ) : (
                                                // ✏️ EDIT MODE (Update + Cancel)
                                                <>
                                                    <Button
                                                        id="update-user-btn"  // Add ID here
                                                        onClick={handleAddToTempList}
                                                        title="Update"
                                                        style={{
                                                            backgroundColor: "#295a80",
                                                            borderColor: "#295a80",
                                                            color: "#fff",
                                                            minWidth: "38px",
                                                            height: "38px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <FaPencilAlt size={14} />
                                                    </Button>
                                                </>
                                            )}
                                        </div>
                                    </div>

                                </InputGroup>


                            </Form.Group>

                            {/* Table showing temp entries */}
                            {modalTempList.length > 0 && (
                                <div className="table-responsive">
                                    <table className="tableClass">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "90px" }}>Sr. No.</th>
                                                <th>
                                                    {parseInt(selectedTransmission) === 2
                                                        ? "Phone Number"
                                                        : "Email Address"}
                                                </th>
                                                <th style={{ width: "90px" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ maxHeight: '132px' }}>
                                            {modalTempList.map((item, idx) => (
                                                <tr key={item.id}>
                                                    <td style={{ width: "90px" }}>{idx + 1}</td>
                                                    <td>{item.display}</td>
                                                    <td style={{ width: "90px" }}>
                                                        <div className="actbtn">
                                                            <img
                                                                src={Icon3}
                                                                title="Edit"
                                                                alt="pencil"
                                                                className="editicon"
                                                                width={25}
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => handleEditTemp(item.id)}
                                                            />

                                                            {/* show delete only when NOT editing */}
                                                            {!editingId && (
                                                                <FaTrash
                                                                    title="Delete"
                                                                    className="suspendicon"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => handleRemoveFromTemp(item.id)}
                                                                />
                                                            )}
                                                        </div>
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </Form>
                    </Modal.Body>

                    {/* only show SAVE footer when NOT editing */}
                    {!editingId && (
                        <Modal.Footer
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Button
                                variant="primary"
                                onClick={handleSaveFromModal}
                                style={{
                                    backgroundColor: "#325880",
                                    borderColor: "#325880",
                                    padding: "6px 24px",
                                    fontWeight: 600,
                                    letterSpacing: "0.5px",
                                }}
                            >
                                SAVE
                            </Button>
                        </Modal.Footer>
                    )}
                </Modal>


                <Modal show={emailModal} onHide={hideEmailSetting} backdrop="static" centered
                    style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)', color: "#465a64", }}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: '20px', fontWeight: "bold" }}>
                            Email Setting
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="emailModal">
                            <label>From Email</label>
                            <input className="esett" type="text" value={setting.email} disabled={true} />
                            <label>From Email Service</label>
                            <input className="esett" type="text" value={setting.service} disabled={true} />
                            <label>Port</label>
                            <input className="esett" type="text" value={setting.port} disabled={true} />
                        </div>
                    </Modal.Body>
                </Modal>



            </div >
            <div className="button-container">
                <button className="save_btn" onClick={submitForm}>
                    SAVE
                </button>
                <button className="reset_btn" onClick={resetForm}>
                    RESET
                </button>
                <Link to={`/EmailConfigurationList`} className="list_btn">
                    LIST
                </Link>
            </div>
        </>
    );
}

export default Home;